import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageSizeOptions from "../PageSizeOptions";
import AddSubcontractor from "./AddSubcontractor";
import Moment from "react-moment";
import moment from "moment";
import ActiveDeactiveHistory from "../SystemAdministration/ManagePartner/ActiveDeactiveHistory";
import { paginate, calculateIndex } from "../../utlis/paginate";
import ReminderAlertMessage from "../ReminderAlertMessage";
import Pagination from "../../comman/pagination";
import SearchableSelect from "../../comman/SearchableSelect";
import {
  loadSubcontractors,
  getAllSubcontractors,
  getFilterAllSubcontractors,
  loadSubcontractorsByFilter,
  SendReminder,
  getReminderStatus,
  filterAllSubcontractorStatus,
  getSubcontractorFilter,
  subsCurrentWfTaskReceived,
  receivedSubcontractorById,
  getAddedSubPerformerStatus,
  loadSubcontractorBprmForm,
  getSubcontractorBprmForm,
} from "../../app/store/subcontractor";
import config from "../../config.json";
import WorkflowElement from "../../app/components/WorkflowElement";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { getFormatedNumber } from "../../services/appService";
import { getAlert } from "../../services/appAlerts";
import {
  getUserProfilePicsById,
  loadUserProfilePicById,
} from "../../app/store/auth";
import {
  getSubcontractorPartners,
  loadSubcontractorPartners,
} from "../../app/store/partner";
import Document from "../PortalForms/Document";
import AchInformation from "../../ReviewTools/AchInformation";
import InsuranseInformation from "../../ReviewTools/InsuranseInformation";
import ViewCandidate from "./ViewCandidate";
import {
  documentReceived,
  esignDocumentsReceived,
  reqDocumentReceived,
  getDocuments,
  getReqDocuments,
  loadDocuments,
  loadReqDocuments,
} from "../../app/store/documents";
import {
  recCurrentWfTaskReceived,
  receivedRecruiterById,
} from "../../app/store/recruiter";
import { formLibraryReceived } from "../../app/store/forms";
import {
  candidateAppsReceived,
  receivedCandidateById,
} from "../../app/store/candidate";

const getInitialValue = (...values) => {
  for (const value of values) {
    if (value) return value;
  }
  return values[values.length - 1];
};

const getTwoLetterInitials = (name, fallback = "SC") => {
  if (!name || !name.trim()) return fallback;
  const words = name.trim().split(/\s+/);
  if (words.length >= 2) {
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  }
  return name.trim().substring(0, 2).toUpperCase();
};

const KeyContactAvatar = ({ contact }) => {
  const dispatch = useDispatch();
  const profilePicsByUserId = useSelector(getUserProfilePicsById);
  const [imageFailed, setImageFailed] = useState(false);
  const performerId = contact?.performerid;
  const hasProfilePic = performerId
    ? Object.prototype.hasOwnProperty.call(profilePicsByUserId, performerId)
    : false;
  const profilePic = performerId ? profilePicsByUserId[performerId] : null;
  const contactName = [contact?.performername, contact?.lastName]
    .filter(Boolean)
    .join(" ");

  useEffect(() => {
    setImageFailed(false);
    if (performerId && !hasProfilePic) {
      dispatch(loadUserProfilePicById(performerId));
    }
  }, [dispatch, performerId, hasProfilePic]);

  const imageUrl = profilePic
    ? `${process.env.REACT_APP_API_BASEURL}/ProfilePics/${profilePic}`
    : null;

  return (
    <div className="wf-avatar-circle" title={contactName || "Key contact"}>
      {imageUrl && !imageFailed ? (
        <img
          className="wf-avatar-image"
          src={imageUrl}
          alt={contactName ? `${contactName} profile` : "Key contact profile"}
          onError={() => setImageFailed(true)}
        />
      ) : (
        getTwoLetterInitials(contactName)
      )}
    </div>
  );
};

export default function ListSubcontractor() {
  const param = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const type = param?.type;
  const route = type === "partner"
    ? [
        { name: "System Administration", url: "" },
        { name: "Manage Entities", url: "" },
      ]
    : [{ name: "Onboarding and Contracts", url: "" }];

  const candidateListLink = location.state?.fromCandidateList ? location.state : null;
  const restoredCandidateList = location.state?.restoreCandidateList
    ? (location.state.candidateListState || { currentPage: 1, pageSize: 5, dataType: "" })
    : null;
  const restoredPartnerList = location.state?.restoreSubcontractorList
    ? location.state.subcontractorListState
    : null;

  const actionType = "action";
  const isInitiallyLoaded = useRef(false);
  const skipRestoredAllSync = useRef(Boolean(restoredPartnerList));
  const skipRestoredFilterSync = useRef(Boolean(restoredPartnerList));

  const [partnerType] = useState("Sub-Contractors");
  const [subcontractors, setSubcontractors] = useState(
    getInitialValue(restoredPartnerList?.subcontractors, []),
  );
  const [rowsCount, setRowsCount] = useState(
    getInitialValue(restoredPartnerList?.rowsCount, 0),
  );
  const [currentPage, setCurrentPage] = useState(
    getInitialValue(restoredPartnerList?.currentPage, restoredCandidateList?.currentPage, 1),
  );
  const [pageSize, setPageSize] = useState(
    getInitialValue(restoredPartnerList?.pageSize, restoredCandidateList?.pageSize, 5),
  );
  const [startIndex, setStartIndex] = useState(
    getInitialValue(restoredPartnerList?.startIndex, 0),
  );
  const [endIndex, setEndIndex] = useState(
    getInitialValue(restoredPartnerList?.endIndex, 5),
  );
  const [remainderMsgShowHide, setRemainderMsgShowHide] = useState(false);
  const [selectedObj, setSelectedObj] = useState(
    getInitialValue(restoredPartnerList?.selectedObj, null),
  );
  const [subId, setSubId] = useState(restoredPartnerList?.subId || "");
  const [subcontractorId, setSubcontractorId] = useState(
    restoredPartnerList?.subcontractorId || "",
  );
  const [subName, setSubName] = useState("");
  const [subEmail, setSubEmail] = useState(restoredPartnerList?.subEmail || "");
  const [dataType, setDataType] = useState(restoredPartnerList?.dataType || "");
  const [selectedSubcontractorId, setSelectedSubcontractorId] = useState(
    restoredPartnerList?.selectedSubcontractorId || 0,
  );
  const [selectedTab, setSelectedTab] = useState("home");
  const [updatedStateData, setUpdatedStateData] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [wfTask, setWfTask] = useState(null);
  const [selectedWorkflowItem, setSelectedWorkflowItem] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null);
  const [selectedCurrentTask, setSelectedCurrentTask] = useState(null);
  const [appDocuments] = useState([]);
  const [, setViewBprmFormShowHide] = useState(false);
  const [filterShowHide, setFilterShowHide] = useState(false);
  const [filterSubcontractorList, setFilterSubcontractorList] = useState([]);

  const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
  const allSubcontractors = useSelector(getAllSubcontractors);
  const filterAllSubcontractors = useSelector(getFilterAllSubcontractors);
  const remiderStatus = useSelector(getReminderStatus);
  const subcontractorFilterdata = useSelector(getSubcontractorFilter);
  const isLoading = useSelector(getAddedSubPerformerStatus);
  const subcontractorPartnersSelector = useSelector(getSubcontractorPartners);
  const appDocumentSelector = useSelector(getDocuments);
  const reqDocumentsSelector = useSelector(getReqDocuments);

  useEffect(() => {
    setWfForm(subcontractorBprmFormSelector);
  }, [subcontractorBprmFormSelector]);

  useEffect(() => {
    if (selectedTab === "onboardingForm" && selectedObj) {
      setWfForm(null);
      let appCiid = 0;
      if (selectedObj.applications?.length > 0) {
        const allWfTasks = selectedObj.applications[0].workflowTasks;
        if (allWfTasks?.length > 0) {
          appCiid = allWfTasks[allWfTasks.length - 1].ciid;
        }
        setUpdatedStateData(selectedObj.applications[0].applicationData);
      } else {
        setUpdatedStateData(selectedObj.contact1?.performerData || "");
      }
      setWfTask({ formId: config.formIds.subcontractor, ciid: appCiid });
      dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor));
    }
  }, [selectedObj, selectedTab, dispatch]);

  useEffect(() => {
    dispatch(setCurrentRoute(route));
    dispatch(setCurrentPageTitle("Subcontractors"));
    dispatch(loadSubcontractorPartners("Sub-Contractors"));

    if (restoredPartnerList) {
      isInitiallyLoaded.current = true;
    } else if (restoredCandidateList) {
      setDataType(restoredCandidateList.dataType || "");
      isInitiallyLoaded.current = true;
      if (restoredCandidateList.dataType !== "filter") {
        dispatch(loadSubcontractors(restoredCandidateList.pageSize, restoredCandidateList.currentPage, partnerType));
      }
    }
  }, []);

  useEffect(() => {
    const autoFilter = candidateListLink?.partnerListFilter;
    if (!autoFilter) return;

    setDataType("filter");
    setSubId(autoFilter.id || "");
    setSubName(autoFilter.name || "");
    setSubEmail(autoFilter.email || "");
    isInitiallyLoaded.current = true;

    const frmBody = new FormData();
    frmBody.append("id", autoFilter.id || "");
    frmBody.append("name", autoFilter.name || "");
    frmBody.append("email", autoFilter.email || "");
    frmBody.append("type", partnerType || "");
    dispatch(loadSubcontractorsByFilter(frmBody));
    dispatch(
      filterAllSubcontractorStatus({
        id: autoFilter.id || "",
        name: autoFilter.name || "",
        email: autoFilter.email || "",
        dataType: "filter",
      }),
    );
  }, []);

  useEffect(() => {
    document.body.classList.add("workflow-user-card-scroll");
    return () => {
      document.body.classList.remove("workflow-user-card-scroll");
    };
  }, []);

  useEffect(() => {
    if (!candidateListLink && subcontractorFilterdata?.dataType === "filter" && dataType !== "filter") {
      setSubId("");
      setSubcontractorId("");
      setSubName("");
      setSubEmail("");
      dispatch(filterAllSubcontractorStatus(""));

      if (!isInitiallyLoaded.current) {
        dispatch(loadSubcontractors(pageSize, currentPage, partnerType));
        isInitiallyLoaded.current = true;
      }

      return;
    }

    if (subcontractorFilterdata === "" && selectedTab === "home") {
      if (!isInitiallyLoaded.current) {
        dispatch(loadSubcontractors(pageSize, currentPage, partnerType));
        isInitiallyLoaded.current = true;
      }
    } else if (subcontractorFilterdata.dataType === "filter") {
      setSubId(subcontractorFilterdata.id);
      setSubName(subcontractorFilterdata.name);
      setSubEmail(subcontractorFilterdata.entity);
    }
  }, [selectedTab]);

  useEffect(() => {
    if (skipRestoredAllSync.current) {
      skipRestoredAllSync.current = false;
      return;
    }
    setRowsCount(allSubcontractors?.[0]?.totalPartners || 0);
    setSubcontractors(allSubcontractors || []);
  }, [allSubcontractors]);

  useEffect(() => {
    if (skipRestoredFilterSync.current) {
      skipRestoredFilterSync.current = false;
      return;
    }
    if (dataType !== "filter") return;

    setCurrentPage(1);
    setPageSize(5);
    getPagedData(filterAllSubcontractors, 1, 5);
  }, [filterAllSubcontractors]);

  useEffect(() => {
    if (remiderStatus === "success") {
      getAlert("", "Reminder Sent Successfully", "success");
      if (dataType === "filter")
        getPagedData(filterAllSubcontractors, currentPage, pageSize);
      else dispatch(loadSubcontractors(pageSize, currentPage, partnerType));
    }
  }, [remiderStatus]);

  useEffect(() => {
    setFilterSubcontractorList(subcontractorPartnersSelector);
  }, [subcontractorPartnersSelector]);

  useEffect(() => {
    const autoFilterId = candidateListLink?.partnerListFilter?.id;
    if (!autoFilterId || subcontractors.length === 0) return;

    const matchedSubcontractor = subcontractors.find(
      (item) => String(item.fuid) === String(autoFilterId),
    );

    if (matchedSubcontractor && selectedSubcontractorId !== matchedSubcontractor.fuid) {
      handleSelectSubcontrator(matchedSubcontractor);
    }
  }, [subcontractors, candidateListLink, selectedSubcontractorId]);

  const getDocsCountForApp = (applicantObj, appDocSelector, reqDocSelector) => {
    if (!applicantObj) return 0;

    const appDocs = (appDocSelector || []).filter((x) => x.uploadType !== "req");
    const reqDocs = reqDocSelector || [];

    const filterDocs = appDocs.filter(
      (x) => x.updType !== "Messaging" && x.deleteFlag !== true
    );

    let sentDocuments = [];
    let filterReqDocs = [];

    if (applicantObj?.subcontractor?.parentid > 0) {
      sentDocuments = filterDocs.filter(
        (x) =>
          x.deleteFlag !== true &&
          x.uploaderId !== applicantObj?.subcontractor?.parentid &&
          x.uploaderId !== applicantObj?.id &&
          x.receiverId !== applicantObj?.id
      );

      filterReqDocs = reqDocs.filter(
        (x) => x.performerId === applicantObj?.subcontractor?.parentid
      );
    } else {
      sentDocuments = filterDocs.filter(
        (x) => x.deleteFlag !== true && x.uploaderId !== applicantObj?.id
      );

      filterReqDocs = reqDocs.filter(
        (x) => x.performerId === applicantObj?.id
      );
    }

    const sentCount = sentDocuments.filter(
      (x) =>
        x.uploadType !== "client" &&
        x.uploadType !== "reporting" &&
        x.uploadType !== "project" &&
        x.uploadType !== "agency" &&
        x.uploadType !== "msp" &&
        x.uploadType !== "ProjectInfo" &&
        x.updType !== "internal" &&
        x.updType !== "Invoice" &&
        !(x.updType && x.updType.includes("req_"))
    ).length;

    const reqCount = filterReqDocs.length;

    return sentCount + reqCount;
  };

  const docsCount = getDocsCountForApp(selectedWorkflowItem, appDocumentSelector, reqDocumentsSelector);

  const handlePageChange = (page) => {
    const { startIndex: start, endIndex: end } = calculateIndex(
      page,
      startIndex,
      endIndex,
    );
    setCurrentPage(page);
    setStartIndex(start);
    setEndIndex(end);
    handleResetSelection();
    if (dataType === "filter")
      getPagedData(filterAllSubcontractors, page, pageSize);
    else dispatch(loadSubcontractors(pageSize, page, partnerType));
  };

  const handlePageSizeChanged = ({ currentTarget }) => {
    setPageSize(currentTarget.value);
    setCurrentPage(1);
    setStartIndex(0);
    setEndIndex(5);
    handleResetSelection();
    if (dataType === "filter")
      getPagedData(filterAllSubcontractors, 1, currentTarget.value);
    else dispatch(loadSubcontractors(currentTarget.value, 1, partnerType));
  };

  useEffect(() => {
    setFilterSubcontractorList(subcontractorPartnersSelector);
  }, [subcontractorPartnersSelector]);

  useEffect(() => {
    const autoFilterId = candidateListLink?.partnerListFilter?.id;
    if (!autoFilterId || subcontractors.length === 0) return;

    const matchedSubcontractor = subcontractors.find(
      (item) => String(item.fuid) === String(autoFilterId),
    );

    if (matchedSubcontractor && selectedSubcontractorId !== matchedSubcontractor.fuid) {
      handleSelectSubcontrator(matchedSubcontractor);
    }
  }, [subcontractors, candidateListLink, selectedSubcontractorId]);

  const handleFilter = () => {
    setDataType("filter");

    var frmBody = new FormData();
    frmBody.append("id", !subId ? "" : subId);

    if (subcontractorId && !subId) frmBody.append("id", subcontractorId);

    frmBody.append("name", !subName ? "" : subName);
    frmBody.append("email", !subEmail ? "" : subEmail);
    frmBody.append("type", !partnerType ? "" : partnerType);
    dispatch(loadSubcontractorsByFilter(frmBody));
    dispatch(
      filterAllSubcontractorStatus({
        id: subId,
        name: subName,
        email: subEmail,
        dataType: "filter",
      }),
    );
  };

  const handleFilterCancel = (type) => {
    if (type === "close" && filterShowHide) setFilterShowHide(false);
    setDataType("");
    setSubId("");
    setSubcontractorId("");
    setSubName("");
    setSubEmail("");
    setCurrentPage(1);
    setPageSize(5);
    dispatch(loadSubcontractors(5, 1, partnerType));
    dispatch(filterAllSubcontractorStatus(""));
  };

  const handleRefresh = () => {
    subcontractors.forEach((subcontractor) => {
      const keyContactId = subcontractor?.contact1?.performerid;
      if (keyContactId) {
        dispatch(loadUserProfilePicById(keyContactId, true));
      }
    });

    if (dataType === "filter") handleFilter();
    else dispatch(loadSubcontractors(pageSize, currentPage, partnerType));
  };

  const getPagedData = (list, currentPage, pageSize) => {
    const items = paginate(list, currentPage, pageSize);
    setRowsCount(
      items?.[0]?.totalPartners ||
      list?.[0]?.totalPartners ||
      list?.length ||
      0,
    );
    setSubcontractors(items);
  };

  const handleRemainder = async (id) => {
    dispatch(SendReminder(id));
  };

  const handleRemainderMessage = () => {
    setRemainderMsgShowHide(!remainderMsgShowHide);
  };

  const handlePartnerPerformer = () => {
    if (selectedSubcontractorId > 0)
      navigate("/ManagePartnerPerformer", {
        state: {
          obj: selectedObj,
          partner: "Subcontractors",
          url: "ListSubcontractor/partner",
          returnTo: "/ListSubcontractor/" + (type || "partner"),
          subcontractorListState: {
            currentPage,
            pageSize,
            startIndex,
            endIndex,
            dataType,
            subcontractors,
            rowsCount,
            subId,
            subcontractorId,
            subEmail,
            selectedObj,
            selectedSubcontractorId,
          },
        },
      });
  };

  const getLastWorkflowTask = (workflowTasks) => {
    if (!workflowTasks?.length) return null;
    const allTasks = workflowTasks.filter(
      (x) =>
        x.itemType === 1 &&
        x.applicantId !== x.performerId &&
        x.taskDoneStatus > 0,
    );
    if (allTasks.length === 0) {
      return workflowTasks[workflowTasks.length - 1];
    }
    const tsk = allTasks[allTasks.length - 1];
    return tsk;
  };

  const handlePartnerApplication = (item, app) => {
    navigate("/ReviewTask", {
      state: {
        task: getLastWorkflowTask(app.workflowTasks),
        item,
        app,
        type: type,
        parentApplication: null,
        appType: "partner",
        module: "Subcontractor",
        returnTo: `/ListSubcontractor/${type || "application"}`,
        candidateListState: {
          currentPage,
          pageSize,
          dataType,
        },
      },
    });
  };
  const handleSelectSubcontrator = (item, forceSelect = false) => {
    if (!forceSelect && selectedSubcontractorId === item.fuid) {
      handleResetSelection();
    } else {
      setSelectedSubcontractorId(item.fuid);
      setSelectedObj(item);
      if (item?.applications?.length > 0) {
        const app = item.applications[0];
        setSelectedWorkflowItem(item);
        setSelectedApp(app);
        const wfTask = getLastWorkflowTask(app?.workflowTasks);
        setSelectedCurrentTask(wfTask);
        if (wfTask?.ciid > 0) {
          dispatch(loadDocuments(wfTask.ciid));
          dispatch(loadReqDocuments(wfTask.ciid));
        }
      }
    }
  };



  const handleResetSelection = () => {
    setSelectedSubcontractorId(0);
    setSelectedObj(null);
    setSelectedWorkflowItem(null);
    setSelectedApp(null);
    setSelectedCurrentTask(null);
    setUpdatedStateData(null);
    setWfForm(null);
    setWfTask(null);
    dispatch(documentReceived([]));
    dispatch(reqDocumentReceived([]));
  };

  const handlePermissionShowHide2 = () => {
    dispatch(loadSubcontractors(pageSize, currentPage, partnerType));
    setSelectedTab("home");
  };

  const handleAddEditSubcontractor = (data, isChanged = false) => {
    if (!data || data === "exit") {
      if (isChanged) {
        if (dataType === "filter")
          getPagedData(filterAllSubcontractors, currentPage, pageSize);
        else dispatch(loadSubcontractors(pageSize, currentPage, partnerType));
      }

      setSelectedTab("home");
      setSelectedObj(null);
      setSelectedSubcontractorId(0);
    }
  };

  const handleTabOnSelect = (tab) => {
    setSelectedTab(tab);
  };

  const clearWorkflowPanelData = () => {
    dispatch(documentReceived([]));
    dispatch(subsCurrentWfTaskReceived(null));
    dispatch(recCurrentWfTaskReceived(null));
    dispatch(formLibraryReceived([]));
    dispatch(reqDocumentReceived([]));
    dispatch(esignDocumentsReceived([]));
    dispatch(candidateAppsReceived([]));
    dispatch(receivedSubcontractorById([]));
    dispatch(receivedCandidateById([]));
    dispatch(receivedRecruiterById([]));
  };

  const handleWorkflowPanelOpen = (tab, item, app) => {
    clearWorkflowPanelData();
    handleSelectSubcontrator(item, true);
    setSelectedWorkflowItem(item);
    setSelectedApp(app);
    const wfTask = getLastWorkflowTask(app?.workflowTasks);
    setSelectedCurrentTask(wfTask);
    setSelectedTab(tab);
    if (wfTask?.ciid > 0) {
      dispatch(loadDocuments(wfTask.ciid));
      dispatch(loadReqDocuments(wfTask.ciid));
    }
  };

  const handleOpenSubcontractorForm = (item) => {
    handleSelectSubcontrator(item, true);
    if (type === "application") {
      setSelectedTab("onboardingForm");
      let appCiid = 0;
      if (item.applications?.length > 0) {
        const allWfTasks = item.applications[0].workflowTasks;
        if (allWfTasks?.length > 0) {
          appCiid = allWfTasks[allWfTasks.length - 1].ciid;
        }
        setUpdatedStateData(item.applications[0].applicationData);
      } else {
        setUpdatedStateData(item.contact1?.performerData || "");
      }
      setWfTask({ formId: config.formIds.subcontractor, ciid: appCiid });
      dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor));
    }
  };

  const handleSearchShowHide = () => {
    setFilterShowHide(!filterShowHide);
    setSubcontractorId("");
    setSubId("");
    setSubName("");
    setSubEmail("");
    if (!filterShowHide) {
      if (subcontractorPartnersSelector.length === 0)
        dispatch(loadSubcontractorPartners("Sub-Contractors"));
    }
  };

  const getInitial = (name) => {
    return getTwoLetterInitials(name);
  };

  const getContactName = (contact) => {
    if (!contact) return "No contact assigned";
    const name = [contact.performername, contact.lastName]
      .filter(Boolean)
      .join(" ");
    return name || "No contact assigned";
  };

  const getContactEmail = (item) =>
    type === "application" ? item?.email : item?.contact1?.performeremail;

  const getActivationStatus = (contact) => {
    if (contact?.isActive === true) {
      return {
        label: "Activated",
        icon: "fa-check-circle",
        className: "is-complete",
      };
    }
    if (contact?.isActive === false) {
      return {
        label: "Deactivated",
        icon: "fa-times-circle",
        className: "is-danger",
      };
    }
    return { label: "To activate", icon: "fa-clock-o", className: "is-muted" };
  };

  const getAddressLines = (item) => {
    const firstLine = item?.accessKey || "";
    const secondLine = [item?.portalUrl, item?.city, item?.state, item?.zip]
      .filter(Boolean)
      .join(", ");

    return [firstLine, secondLine].filter(Boolean);
  };

  return (
    <React.Fragment>
      <style>{`
        @keyframes searchSlideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes shimmer {
          0%   { background-position: -600px 0; }
          100% { background-position: 600px 0; }
        }

        @keyframes loadingBar {
          0%   { width: 0%; opacity: 1; }
          70%  { width: 85%; opacity: 1; }
          100% { width: 100%; opacity: 0; }
        }

        .wf-loading-bar {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #171717, #737373, #171717);
          background-size: 200% 100%;
          animation: loadingBar 1.6s ease-in-out infinite;
          z-index: 10;
        }

        .skeleton-cell {
          display: block;
          height: 13px;
          border-radius: 6px;
          background: linear-gradient(
            90deg,
            #f1f5f9 25%,
            #e2e8f0 50%,
            #f1f5f9 75%
          );
          background-size: 600px 100%;
          animation: shimmer 1.4s ease-in-out infinite;
        }

        .skeleton-cell.sk-short  { width: 40%; }
        .skeleton-cell.sk-medium { width: 65%; }
        .skeleton-cell.sk-long   { width: 85%; }
        .skeleton-cell.sk-full   { width: 92%; }
        .skeleton-cell.sk-radio  {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          margin: 0 auto;
        }

        .skeleton-cell.sk-avatar {
          width: 34px;
          height: 34px;
          border-radius: 10px;
          flex: 0 0 auto;
        }

        .skeleton-row td {
          padding: 14px 16px !important;
        }

        .skeleton-identity {
          display: flex;
          align-items: flex-start;
          gap: 10px;
        }

        .skeleton-stack {
          display: flex;
          flex-direction: column;
          gap: 8px;
          width: 100%;
        }

        .wf-main-card {
          background: #ffffff !important;
          border: 1px solid rgba(226, 232, 240, 0.8) !important;
          box-shadow: none !important;
          border-radius: 0 !important;
          transition: all 0.3s ease !important;
          overflow: hidden !important;
          position: relative !important;
          height: auto !important;
          min-height: 420px !important;
          display: flex !important;
          flex-direction: column !important;
          margin-bottom: 0 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          font-size: 14px !important;
        }

        .wf-card-header-bar {
          position: relative !important;
          overflow: hidden !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 12px !important;
          padding: 14px 20px !important;
          border-bottom: 1px solid #f1f5f9 !important;
          background: #ffffff !important;
          border-radius: 0 !important;
          flex: 0 0 auto !important;
        }

        .wf-header-left {
          display: flex;
          align-items: center;
          gap: 14px;
          flex-wrap: wrap;
        }

        .wf-header-actions {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 10px;
          flex-wrap: wrap;
        }

        .wf-header-action-btn {
          min-height: unset !important;
          padding: 7px 14px !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          background: #ffffff !important;
          color: #1e293b !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          line-height: 1.25 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
        }

        .wf-header-action-btn:hover {
          background: #f8fafc !important;
          border-color: #94a3b8 !important;
          color: #0f172a !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }

        .wf-header-action-btn i {
          font-size: 14px !important;
          margin: 0 !important;
          color: inherit !important;
        }

        .wf-stats-chip {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: transparent;
          border: 1px solid rgba(100, 116, 139, 0.18);
          color: #1e293b;
          border-radius: 0;
          padding: 5px 12px;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.2px;
        }

        .wf-stats-chip i {
          font-size: 14px;
          color: #1e293b;
        }

        .search-panel-collapse {
          background: #ffffff !important;
          border: 1px solid rgba(203, 213, 225, 0.7) !important;
          border-radius: 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
          animation: searchSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1) both;
          margin-top: 12px !important;
          margin-bottom: 8px !important;
          overflow: hidden !important;
        }

        .sp-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 20px 12px;
          border-bottom: 1px solid rgba(226, 232, 240, 0.8);
          background: #ffffff !important;
        }

        .sp-header-title {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          letter-spacing: 0.1px;
        }

        .sp-header-title i {
          color: #64748b;
          font-size: 14px;
        }

        .sp-header-badge {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          background: rgba(37, 99, 235, 0.07);
          border: 1px solid rgba(37, 99, 235, 0.15);
          color: #1d4ed8;
          border-radius: 0;
          padding: 3px 10px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.3px;
          text-transform: uppercase;
        }

        .search-panel-collapse input,
        .search-panel-collapse textarea,
        .search-panel-collapse select {
          font-weight: 400 !important;
        }
        .search-panel-collapse input::placeholder,
        .search-panel-collapse textarea::placeholder {
          font-weight: 400 !important;
          color: #94a3b8 !important;
        }
        .search-panel-collapse [class*="-placeholder"] {
          font-weight: 400 !important;
          color: #94a3b8 !important;
        }

        .sp-body {
          padding: 18px 20px 14px;
        }

        .sp-footer {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 20px;
          border-top: 1px solid rgba(226, 232, 240, 0.7);
          background: #ffffff;
        }

        .wf-control-label {
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          text-transform: uppercase !important;
          letter-spacing: 0.7px !important;
          margin-bottom: 7px !important;
          display: flex !important;
          align-items: center !important;
          gap: 5px !important;
        }

        .wf-control-label i {
          color: #94a3b8;
          font-size: 12px;
        }

        .wf-input-wrap {
          position: relative;
        }

        .wf-input-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 14px;
          pointer-events: none;
          transition: color 0.2s ease;
          z-index: 1;
        }

        .wf-input-wrap:focus-within .wf-input-icon {
          color: #2563eb;
        }

        .wf-input {
          border-radius: 0 !important;
          border: 1.5px solid #e2e8f0 !important;
          padding: 9px 14px 9px 36px !important;
          font-size: 14px !important;
          font-weight: 400 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          height: auto !important;
          width: 100% !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
        }

        .wf-input::placeholder {
          color: #94a3b8 !important;
          font-weight: 400 !important;
        }

        .wf-input:hover {
          border-color: #94a3b8 !important;
          box-shadow: 0 2px 6px -1px rgba(0,0,0,0.06) !important;
        }

        .wf-input:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important;
          background: #fafbff !important;
        }

        .wf-select {
          appearance: none !important;
          -webkit-appearance: none !important;
          background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 14px center !important;
          padding-right: 36px !important;
        }

        .btn-action-search.btn-danger-search {
          background: #ffffff !important;
          color: #991b1b !important;
          border: 1px solid #fca5a5 !important;
          box-shadow: 0 2px 5px rgba(220, 38, 38, 0.12) !important;
        }

        .btn-action-search.btn-danger-search:hover {
          background: #fff5f5 !important;
          color: #7f1d1d !important;
          border-color: #f87171 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(220, 38, 38, 0.16) !important;
        }

        /* ── Premium Tabs ─────────────────────────────── */
        .wf-tab-bar {
          display: flex !important;
          align-items: stretch !important;
          gap: 4px !important;
          border-bottom: 2px solid #e5e5e5 !important;
          margin-bottom: 0 !important;
          padding: 8px 0 0 !important;
          position: relative !important;
          flex: 0 0 auto !important;
        }

        .wf-tab-btn {
          position: relative !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          border: none !important;
          background: transparent !important;
          padding: 9px 16px 11px !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          border-radius: 0 !important;
          transition: color 0.2s ease, background 0.2s ease !important;
          outline: none !important;
          white-space: nowrap !important;
        }

        .wf-tab-btn i {
          font-size: 14px !important;
          color: currentColor !important;
          transition: color 0.2s ease !important;
        }

        .wf-tab-btn:hover {
          color: #0f172a !important;
          background: #f5f5f5 !important;
        }

        .wf-tab-btn:focus,
        .wf-tab-btn:focus-visible,
        .wf-tab-btn:active {
          outline: none !important;
          box-shadow: none !important;
          border-color: transparent !important;
        }

        .wf-tab-btn.active {
          color: #ffffff !important;
          background: #171717 !important;
        }

        .wf-tab-btn.active i {
          color: #ffffff !important;
        }

        .wf-tab-btn::after {
          content: "" !important;
          position: absolute !important;
          bottom: -2px !important;
          left: 0 !important;
          right: 0 !important;
          height: 2px !important;
          background: #171717 !important;
          border-radius: 2px 2px 0 0 !important;
          transform: scaleX(0) !important;
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        .wf-tab-btn.active::after {
          transform: scaleX(0) !important;
        }

        .wf-tab-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          min-width: 20px !important;
          height: 20px !important;
          padding: 0 6px !important;
          border-radius: 0 !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          background: #f1f5f9 !important;
          color: #64748b !important;
          border: 1px solid #e2e8f0 !important;
          transition: all 0.2s ease !important;
          line-height: 1 !important;
        }

        .wf-tab-btn.active .wf-tab-badge {
          background: #ffffff !important;
          color: #171717 !important;
          border-color: #ffffff !important;
        }

        .wf-tab-btn.tab-locked .wf-tab-badge {
          background: rgba(245,158,11,0.1);
          color: #b45309;
          border-color: rgba(245,158,11,0.2);
        }

        /* Tab content panels */
        @keyframes tabFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-tab-panel {
          animation: tabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both;
          flex: 1 1 auto;
          min-height: auto;
          overflow-y: visible;
          overflow-x: hidden;
          padding-right: 4px;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        body.workflow-user-card-scroll #layout-scroll-wrapper {
          overflow-y: auto !important;
        }

        body.workflow-user-card-scroll .modern-breadcrumb-container {
          margin-bottom: 10px !important;
        }

        .wf-main-card > .card-body:not(.wf-tabs-container) {
          flex: 1 1 auto !important;
          min-height: auto !important;
          overflow-y: visible !important;
          overflow-x: hidden !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }

        .wf-tabs-container {
          display: flex;
          flex: 1 1 auto !important;
          flex-direction: column;
          min-height: auto !important;
          overflow: visible !important;
        }

        .wf-tab-panel::-webkit-scrollbar,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .wf-tab-panel::-webkit-scrollbar-track,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 999px;
        }

        .wf-tab-panel::-webkit-scrollbar-thumb,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
          border-radius: 999px;
          border: 2px solid #f1f5f9;
        }

        .wf-tab-panel::-webkit-scrollbar-thumb:hover,
        .wf-main-card > .card-body:not(.wf-tabs-container)::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
        }

        /* Enhanced empty state */
        .wf-empty-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 24px;
          text-align: center;
          gap: 12px;
          animation: tabFadeIn 0.3s ease both;
        }

        .wf-empty-icon {
          width: 52px;
          height: 52px;
          border-radius: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          color: #2563eb;
          margin-bottom: 4px;
        }

        .wf-empty-title {
          font-size: 15px;
          font-weight: 600;
          color: #1e293b;
          margin: 0;
          width: 100%;
          text-align: center;
        }

        .wf-empty-desc {
          font-size: 13px;
          color: #64748b;
          margin: 0 auto;
          line-height: 1.6;
          text-align: center;
          width: 100%;
        }

        /* Modern Table Style */
        .wf-table {
          width: 100% !important;
          border-collapse: collapse !important;
          border: none !important;
        }

        .wf-table-scroll {
          width: 100% !important;
          overflow: auto !important;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
          border-radius: 0 !important;
          border: 1px solid #e2e8f0 !important;
          background: #ffffff !important;
        }

        .wf-thead {
          background: #f8fafc !important;
          position: sticky !important;
          top: 0 !important;
          z-index: 2 !important;
        }

        .wf-thead th {
          font-size: 11.5px !important;
          font-weight: 600 !important;
          color: #475569 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.6px !important;
          padding: 13px 16px !important;
          border-bottom: 2px solid #e2e8f0 !important;
          border-top: none !important;
          border-left: none !important;
          border-right: none !important;
          white-space: nowrap !important;
        }

        .wf-table-row {
          cursor: pointer !important;
          transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
        }

        .wf-table-row:hover {
          background: #f5f5f5 !important;
          box-shadow: inset 3px 0 0 0 #171717 !important;
        }

        .wf-table-row:hover td {
          color: #000000 !important;
        }

        .wf-table-row:active {
          transform: scaleY(0.98) !important;
        }

        .wf-table-row.selected-row {
          background: #f5f5f5 !important;
          box-shadow: inset 4px 0 0 0 #171717 !important;
        }

        .wf-table-row.selected-row:hover {
          background: #eeeeee !important;
        }

        .wf-table td {
          padding: 13px 16px !important;
          font-size: 13px !important;
          color: #000000 !important;
          border-left: none !important;
          border-right: none !important;
          border-bottom: 1px solid #f1f5f9 !important;
          vertical-align: middle !important;
          transition: color 0.15s ease !important;
        }

        .wf-table-row.selected-row td {
          color: #1e3a8a !important;
          font-weight: 600 !important;
          border-bottom: 1px solid rgba(37, 99, 235, 0.08) !important;
        }

        .wf-table tbody tr:last-child td {
          border-bottom: none !important;
        }

        /* Row index fade-in */
        @keyframes rowFadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-table-row {
          animation: rowFadeIn 0.25s ease both !important;
        }

        /* Pill Badges */
        .badge-capsule {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 78px !important;
          min-width: 78px !important;
          text-align: center !important;
          padding: 4px 6px !important;
          border-radius: 0 !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          line-height: 1 !important;
          box-sizing: border-box !important;
        }

        .badge-unrestricted {
          background: #f1f5f9 !important;
          color: #475569 !important;
          border: 1px solid #cbd5e1 !important;
        }

        .badge-count {
          background: rgba(37, 99, 235, 0.08) !important;
          color: #1d4ed8 !important;
          border: 1px solid rgba(37, 99, 235, 0.15) !important;
        }

        .badge-users {
          background: rgba(16, 185, 129, 0.08) !important;
          color: #047857 !important;
          border: 1px solid rgba(16, 185, 129, 0.15) !important;
        }

        .badge-zero {
          background: #f8fafc !important;
          color: #64748b !important;
          border: 1px solid #e2e8f0 !important;
        }

        /* Alert Warning */
        .wf-alert-warning {
          background: rgba(239, 68, 68, 0.04) !important;
          border: 1px solid rgba(239, 68, 68, 0.15) !important;
          border-radius: 12px !important;
          padding: 16px 20px !important;
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          margin-top: 10px !important;
          animation: searchSlideDown 0.3s ease-out both;
        }

        .wf-alert-icon {
          color: #dc2626 !important;
          font-size: 20px !important;
        }

        .wf-alert-text {
          color: #dc2626 !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          margin: 0 !important;
        }

        /* Radio Styling */
        .wf-radio-container {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .wf-radio-input {
          width: 16px !important;
          height: 16px !important;
          accent-color: #2563eb !important;
          cursor: pointer !important;
        }

        .wf-table-modern {
          min-width: 0 !important;
          width: 100% !important;
          table-layout: fixed !important;
          border-spacing: 0 !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          overflow: hidden !important;
        }

        .wf-table-modern .wf-thead {
          background: #f8fafc !important;
        }

        .wf-table-modern .wf-thead th {
          padding: 12px 14px !important;
          border-bottom: 1px solid #e5e7eb !important;
          color: #64748b !important;
          font-size: 11px !important;
          letter-spacing: 0.04em !important;
        }

        .wf-table-application .wf-thead th:nth-child(4) {
          white-space: normal !important;
          line-height: 1.2 !important;
          word-break: normal !important;
          overflow-wrap: normal !important;
        }

        .wf-table-modern td {
          padding: 12px 14px !important;
          border-bottom: 1px solid #eef2f7 !important;
          vertical-align: top !important;
          overflow-wrap: anywhere !important;
        }

        .wf-table-modern .wf-table-row {
          cursor: pointer !important;
        }

        .wf-table-modern .wf-table-row:hover {
          background: linear-gradient(90deg, #f5f5f5 0%, #fafafa 100%) !important;
          box-shadow: inset 3px 0 0 0 #171717 !important;
        }

        .wf-table-modern .wf-table-row.selected-row {
          background: linear-gradient(90deg, #f5f5f5 0%, #fafafa 100%) !important;
          box-shadow: inset 4px 0 0 0 #171717 !important;
        }

        @media (min-width: 1600px) {
          .wf-table-application th:nth-child(1),
          .wf-table-application td:nth-child(1) {
            width: 25% !important;
          }

          .wf-table-application th:nth-child(2),
          .wf-table-application td:nth-child(2) {
            width: 35% !important;
          }

          .wf-table-application th:nth-child(3),
          .wf-table-application td:nth-child(3) {
            width: 15% !important;
          }

          .wf-table-application th:nth-child(4),
          .wf-table-application td:nth-child(4) {
            width: 25% !important;
          }
        }

        .wf-table-partner th:nth-child(1),
        .wf-table-partner td:nth-child(1) {
          width: 25% !important;
        }

        .wf-table-partner th:nth-child(2),
        .wf-table-partner td:nth-child(2) {
          width: 35% !important;
        }

        .wf-table-partner th:nth-child(3),
        .wf-table-partner td:nth-child(3) {
          width: 15% !important;
        }

        .wf-table-partner th:nth-child(4),
        .wf-table-partner td:nth-child(4) {
          width: 10% !important;
        }

        .wf-table-partner th:nth-child(5),
        .wf-table-partner td:nth-child(5) {
          width: 15% !important;
        }

        .wf-select-th,
        .wf-select-td {
          width: 58px !important;
          text-align: center !important;
        }

        .wf-reset-selection {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          margin-left: 6px;
          border: 1px solid #dbe3ef;
          border-radius: 7px;
          background: #ffffff;
          color: #2563eb;
          cursor: pointer;
          transition: all 0.18s ease;
        }

        .wf-reset-selection:hover {
          background: #eff6ff;
          border-color: #bfdbfe;
        }

        .wf-identity-cell {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          min-width: 0;
        }

        .wf-avatar-stack {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 6px;
          flex-shrink: 0;
        }

        .wf-avatar-circle {
          width: 40px;
          height: 40px;
          border-radius: 0;
          background: #0f766e;
          color: #ffffff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 15px;
          font-weight: 600;
          letter-spacing: 0.5px;
          flex: 0 0 auto;
          box-shadow: none;
          border: 1px solid #d4d4d4;
          outline: none;
          overflow: hidden;
        }

        .wf-avatar-image {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
        }

        .wf-avatar-check-badge {
          position: absolute;
          top: -4px;
          right: -4px;
          width: 16px;
          height: 16px;
          border-radius: 0;
          background: #2563eb;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 8px;
          border: 1.5px solid #ffffff;
          box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3);
          z-index: 2;
          animation: scaleIn 0.2s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }

        @keyframes scaleIn {
          from {
            transform: scale(0);
          }
          to {
            transform: scale(1);
          }
        }

        .wf-identity-copy {
          display: flex;
          flex-direction: column;
          gap: 6px;
          min-width: 0;
          flex: 1;
        }

        .wf-contact-card {
          display: flex;
          flex-direction: column;
          gap: 6px;
          min-width: 0;
          flex: 1;
        }

        .wf-activation-stack {
          display: flex;
          flex-direction: column;
          gap: 6px;
          min-width: 0;
        }

        .wf-status-stack {
          display: flex;
          flex-direction: column;
          align-items: flex-start !important;
          gap: 4px;
          min-width: 0;
        }

        .wf-identity-heading {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
        }

        .wf-identity-title,
        .wf-contact-name {
          color: #0f172a !important;
          font-size: 14px !important;
          font-weight: 600 !important;
          line-height: 1.3 !important;
          letter-spacing: 0.3px !important;
          text-transform: uppercase !important;
          white-space: normal !important;
          word-break: break-word !important;
          overflow-wrap: break-word !important;
        }

        .wf-identity-meta-row {
          display: flex;
          align-items: flex-start;
          gap: 8px;
          color: #475569;
          font-size: 12px;
          line-height: 1.45;
        }

        .wf-identity-meta-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 18px;
          height: 18px;
          border-radius: 0;
          flex-shrink: 0;
          font-size: 10px;
          margin-top: 1px;
        }

        .wf-icon-email {
          background: #eff6ff;
          color: #2563eb;
        }

        .wf-icon-calendar {
          background: #faf5ff;
          color: #7c3aed;
        }

        .wf-icon-address {
          background: #fff1f2;
          color: #e11d48;
        }

        .wf-icon-user {
          background: #f0fdf4;
          color: #16a34a;
        }

        .wf-icon-phone {
          background: #fff7ed;
          color: #ea580c;
        }

        .wf-app-icon-wrapper {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 0;
          background: #eff6ff;
          color: #2563eb;
          font-size: 11px;
          flex-shrink: 0;
        }

        .wf-identity-meta-text {
          flex: 1;
          min-width: 0;
          word-break: break-word;
          overflow-wrap: break-word;
        }

        .wf-identity-address-text {
          display: flex;
          flex-direction: column;
          gap: 2px;
          line-height: 1.35;
          white-space: normal;
        }

        .wf-identity-address-text span {
          display: block;
        }

        .wf-identity-meta,
        .wf-contact-meta,
        .wf-date-meta,
        .wf-muted-text {
          color: #64748b;
          font-size: 12px;
          line-height: 1.35;
          overflow-wrap: anywhere;
        }

        .wf-inline-id,
        .wf-id-pill,
        .wf-count-pill {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          width: max-content;
          border: 1px solid #dbe3ef;
          border-radius: 0;
          background: #f8fafc;
          color: #334155;
          font-size: 12px;
          font-weight: 600;
          padding: 5px 10px;
        }

        .wf-inline-id {
          padding: 2px 6px;
          font-size: 13px;
          font-weight: 600;
          background: #eff6ff;
          border: 1px solid #dbeafe;
          color: #1d4ed8;
          border-radius: 0;
          letter-spacing: 0.5px;
          line-height: 1;
        }

        .wf-count-pill {
          background: #ecfdf5;
          border-color: #bbf7d0;
          color: #047857;
        }

        .wf-app-list,
        .wf-action-stack {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
        }

        .wf-row-actions {
          display: flex;
          flex-direction: column !important;
          align-items: flex-start !important;
          gap: 6px !important;
        }

        .wf-table i,
        .wf-table-modern i,
        .wf-status-pill i,
        .wf-app-status-badge i,
        .wf-link-action i,
        .btn-action-search i {
          display: inline-block !important;
          font-family: FontAwesome !important;
          font-style: normal !important;
          font-weight: normal !important;
          color: currentColor !important;
          visibility: visible !important;
          opacity: 1 !important;
        }

        .wf-app-list {
          max-width: none !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }

        .wf-app-chip {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          max-width: 100%;
          border: 1px solid #e2e8f0;
          border-radius: 0;
          background: #ffffff;
          color: #334155;
          padding: 6px 8px;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
        }

        .wf-app-type {
          max-width: 128px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
          font-weight: 600;
          color: #1e293b;
        }

        .wf-app-id {
          color: #64748b;
          font-size: 11px;
          font-weight: 600;
        }

        .wf-mini-status,
        .wf-status-pill {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          width: max-content;
          border-radius: 0;
          border: 1px solid #dbe3ef;
          background: #f8fafc;
          color: #475569;
          font-size: 11px;
          font-weight: 600;
          line-height: 1;
          padding: 5px 8px;
          text-transform: uppercase;
        }

        .wf-mini-status.is-complete,
        .wf-status-pill.is-complete {
          background: #ecfdf5;
          border-color: #bbf7d0;
          color: #047857;
        }

        .wf-mini-status.is-review,
        .wf-status-pill.is-pending {
          background: #fff7ed;
          border-color: #fed7aa;
          color: #c2410c;
        }

        .wf-status-pill.is-danger {
          background: #fef2f2;
          border-color: #fecaca;
          color: #dc2626;
        }

        .wf-status-pill.is-muted {
          background: #f8fafc;
          border-color: #e2e8f0;
          color: #64748b;
        }

        .wf-link-action,
        .wf-review-btn,
        .wf-tool-btn {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: 1px solid #dbe3ef;
          border-radius: 0;
          background: #ffffff;
          color: #334155;
          font-size: 12px;
          font-weight: 600;
          transition: all 0.18s ease;
          cursor: pointer;
          white-space: nowrap;
        }

        .wf-link-action {
          background: #eff6ff !important;
          border-color: #bfdbfe !important;
          color: #1d4ed8 !important;
          font-weight: 600 !important;
          padding: 6px 10px !important;
          font-size: 11.5px !important;
        }

        .wf-link-action:hover {
          background: #dbeafe !important;
          border-color: #93c5fd !important;
          color: #1e40af !important;
        }

        .wf-link-action:hover,
        .wf-review-btn:hover,
        .wf-tool-btn:hover {
          background: #f8fafc;
          border-color: #bfdbfe;
          color: #1d4ed8;
          transform: translateY(-1px);
        }

        .wf-review-btn.is-review {
          background: #2563eb;
          border-color: #2563eb;
          color: #ffffff;
        }

        .wf-review-btn.is-review:hover {
          background: #1d4ed8;
          color: #ffffff;
        }

        .wf-review-btn.is-complete {
          background: #ecfdf5;
          border-color: #bbf7d0;
          color: #047857;
        }

        .wf-review-btn span {
          opacity: 0.78;
          font-size: 11px;
        }

        .wf-action-stack {
          align-items: flex-start;
          max-width: 430px;
        }

        .wf-tool-btn.is-docs,
        .wf-tool-btn.is-form,
        .wf-tool-btn.is-ach,
        .wf-tool-btn.is-insurance {
          background: #f8fafc !important;
          border-color: #dbe3ef !important;
          color: #334155 !important;
        }

        .wf-tool-btn.is-docs:hover,
        .wf-tool-btn.is-form:hover,
        .wf-tool-btn.is-ach:hover,
        .wf-tool-btn.is-insurance:hover {
          background: #eff6ff !important;
          border-color: #bfdbfe !important;
          color: #1d4ed8 !important;
        }

        .wf-tool-count {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 18px;
          height: 18px;
          padding: 0 5px;
          border-radius: 0;
          background: #dc2626;
          color: #ffffff;
          font-size: 10px;
          font-weight: 600;
          line-height: 1;
        }

        @media (max-width: 767px) {
          .wf-card-header-bar {
            align-items: flex-start !important;
          }

          .wf-table-modern {
            min-width: 1120px !important;
          }

          .wf-identity-cell {
            min-width: 0;
          }
        }

        @media (max-width: 1199px) {
          .wf-table-scroll {
            overflow-x: auto !important;
            overflow-y: visible !important;
          }

          .wf-table-modern {
            min-width: 1120px !important;
          }

          .wf-table-application th:nth-child(1),
          .wf-table-application td:nth-child(1) {
            width: 25% !important;
          }

          .wf-table-application th:nth-child(2),
          .wf-table-application td:nth-child(2) {
            width: 35% !important;
          }

          .wf-table-application th:nth-child(3),
          .wf-table-application td:nth-child(3) {
            width: 15% !important;
          }

          .wf-table-application th:nth-child(4),
          .wf-table-application td:nth-child(4) {
            width: 25% !important;
          }
        }

        /* Search Actions — matched to WorkflowUser / TopMenu */
        .btn-action-search {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          line-height: 1.25 !important;
        }

        .btn-action-search:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }

        .btn-action-search.btn-primary-search {
          background: #2563eb !important;
          color: #ffffff !important;
          border-color: #2563eb !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }

        .btn-action-search.btn-primary-search:hover {
          background: #1d4ed8 !important;
          color: #ffffff !important;
          transform: none !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }

        .btn-action-search:disabled {
          background: #ffffff !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.04) !important;
          opacity: 1 !important;
        }

        .btn-action-search.btn-primary-search:disabled {
          background: #e2e8f0 !important;
          color: #94a3b8 !important;
          border-color: #cbd5e1 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
          opacity: 1 !important;
        }

        .btn-search-trigger {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 14px !important;
          border-radius: 0 !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          letter-spacing: 0.01em !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
          min-height: unset !important;
          line-height: 1.25 !important;
        }

        .btn-search-trigger:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12) !important;
        }

        /* ── Premium Table Empty State ───────────────────── */
        @keyframes emptyFadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes emptyGlow {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37,99,235,0.18), 0 0 0 8px rgba(37,99,235,0.06); }
          50%       { box-shadow: 0 0 0 6px rgba(37,99,235,0.12), 0 0 0 14px rgba(37,99,235,0.04); }
        }
        @keyframes emptyFloat {
          0%, 100% { transform: translateY(0px);  }
          50%       { transform: translateY(-6px); }
        }
        @keyframes emptyOrbit {
          from { transform: rotate(0deg) translateX(38px) rotate(0deg); }
          to   { transform: rotate(360deg) translateX(38px) rotate(-360deg); }
        }
        @keyframes emptyOrbit2 {
          from { transform: rotate(180deg) translateX(52px) rotate(-180deg); }
          to   { transform: rotate(540deg) translateX(52px) rotate(-540deg); }
        }
        @keyframes emptySparkle {
          0%,100% { opacity:0; transform: scale(0.5) rotate(0deg);   }
          50%      { opacity:1; transform: scale(1)   rotate(180deg); }
        }

        .wf-table-empty {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 56px 24px 48px;
          text-align: center;
          overflow: hidden;
          background: linear-gradient(145deg, #f8faff 0%, #f1f5ff 50%, #faf8ff 100%);
          border-radius: 16px;
          margin: 12px;
          border: 1.5px solid rgba(37,99,235,0.1);
          animation: emptyFadeUp 0.45s cubic-bezier(0.16,1,0.3,1) both;
        }

        .wf-table-empty::before {
          content: '';
          position: absolute;
          width: 260px; 
          height: 260px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(37,99,235,0.07) 0%, transparent 70%);
          pointer-events: none;
          top: -60px; left: -60px;
        }
        .wf-table-empty::after {
          content: '';
          position: absolute;
          width: 200px; height: 200px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(124,58,237,0.06) 0%, transparent 70%);
          pointer-events: none;
          bottom: -40px; right: -40px;
        }

        .wf-te-dots {
          position: absolute;
          inset: 0;
          background-image: radial-gradient(circle, rgba(37,99,235,0.12) 1px, transparent 1px);
          background-size: 22px 22px;
          opacity: 0.35;
          pointer-events: none;
        }

        .wf-te-orbit-wrap {
          position: relative;
          width: 110px; height: 110px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 24px;
          z-index: 1;
        }

        .wf-te-ring {
          position: absolute;
          inset: -6px;
          border-radius: 50%;
          border: 1.5px solid rgba(37,99,235,0.15);
          animation: emptyGlow 2.4s ease-in-out infinite;
        }
        .wf-te-ring2 {
          position: absolute;
          inset: -18px;
          border-radius: 50%;
          border: 1px dashed rgba(37,99,235,0.1);
          animation: emptyGlow 2.4s ease-in-out 0.8s infinite;
        }

        .wf-te-orb {
          position: absolute;
          width: 8px; height: 8px;
          border-radius: 50%;
          background: linear-gradient(135deg,#2563eb,#7c3aed);
          top: 50%; left: 50%;
          margin: -4px 0 0 -4px;
          animation: emptyOrbit 3.5s linear infinite;
          box-shadow: 0 2px 6px rgba(37,99,235,0.35);
        }
        .wf-te-orb2 {
          position: absolute;
          width: 6px; height: 6px;
          border-radius: 50%;
          background: linear-gradient(135deg,#7c3aed,#ec4899);
          top: 50%; left: 50%;
          margin: -3px 0 0 -3px;
          animation: emptyOrbit2 5s linear infinite;
          box-shadow: 0 2px 5px rgba(124,58,237,0.3);
        }

        .wf-te-icon {
          width: 72px; height: 72px;
          border-radius: 50%;
          background: linear-gradient(135deg, #eff6ff 0%, #f5f3ff 100%);
          border: 2px solid rgba(37,99,235,0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 28px;
          color: #2563eb;
          position: relative;
          z-index: 2;
          animation: emptyFloat 3s ease-in-out infinite;
          box-shadow: 0 8px 24px rgba(37,99,235,0.12), 0 2px 8px rgba(0,0,0,0.04);
          transition: all 0.3s ease;
        }
        .wf-table-empty:hover .wf-te-icon {
          background: linear-gradient(135deg,rgba(37,99,235,0.1) 0%,rgba(124,58,237,0.08) 100%);
          border-color: rgba(37,99,235,0.3);
          box-shadow: 0 12px 32px rgba(37,99,235,0.2);
          color: #1d4ed8;
        }

        .wf-te-spark {
          position: absolute;
          width: 6px; height: 6px;
          border-radius: 50%;
          background: #2563eb;
          z-index: 1;
        }

        .wf-te-label {
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #2563eb;
          background: rgba(37,99,235,0.07);
          border: 1px solid rgba(37,99,235,0.12);
          border-radius: 20px;
          padding: 3px 12px;
          margin-bottom: 10px;
          z-index: 1;
        }

        .wf-te-title {
          font-size: 18px;
          font-weight: 600;
          background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin: 0 0 10px 0;
          line-height: 1.3;
          z-index: 1;
        }

        .wf-te-desc {
          font-size: 13.5px;
          color: #64748b;
          margin: 0 0 22px 0;
          max-width: 340px;
          line-height: 1.65;
          z-index: 1;
        }

        .wf-te-cta {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          background: linear-gradient(135deg, #2563eb 0%, #4f46e5 100%) !important;
          color: #ffffff !important;
          border: none !important;
          padding: 10px 22px !important;
          border-radius: 0 !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          cursor: pointer !important;
          transition: all 0.25s ease !important;
          box-shadow: 0 4px 14px rgba(37,99,235,0.3) !important;
          z-index: 1;
          position: relative;
        }
        .wf-te-cta:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 8px 20px rgba(37,99,235,0.4) !important;
          background: linear-gradient(135deg, #1d4ed8 0%, #4338ca 100%) !important;
        }
        .wf-te-cta:active {
          transform: translateY(0px) !important;
        }

        .wf-table-empty-simple {
          background: #ffffff;
          border: 1px dashed #cbd5e1;
          border-radius: 0 !important;
          margin: 16px 0 0;
          padding: 40px 24px;
        }

        .wf-table-empty-simple::before,
        .wf-table-empty-simple::after {
          display: none;
        }

        .wf-simple-empty-icon {
          width: 48px;
          height: 48px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 0 !important;
          background: #eff6ff;
          border: 1px solid #bfdbfe;
          color: #2563eb;
          font-size: 20px;
          margin-bottom: 14px;
          position: relative;
          z-index: 1;
        }

        .wf-table-empty-simple .wf-te-title {
          background: none;
          -webkit-text-fill-color: #0f172a;
          color: #0f172a;
        }

        .wf-panel-shell {
          background: #ffffff;
          border: 1px solid #e5e7eb;
          border-radius: 0 !important;
          padding: 16px;
        }

        .wf-panel-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 12px;
          padding-bottom: 14px;
          margin-bottom: 14px;
          border-bottom: 1px solid #eef2f7;
        }

        .wf-panel-title {
          margin: 0;
          color: #0f172a;
          font-size: 16px;
          font-weight: 600;
          line-height: 1.25;
        }

        .wf-panel-subtitle {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 6px;
          color: #64748b;
          font-size: 12px;
          font-weight: 600;
        }

        .wf-panel-close {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          border: 1px solid #dbe3ef;
          border-radius: 0 !important;
          background: #ffffff;
          color: #334155;
          font-size: 12px;
          font-weight: 600;
          padding: 7px 10px;
          transition: all 0.18s ease;
        }

        .wf-panel-close:hover {
          background: #f8fafc;
          color: #1d4ed8;
          border-color: #bfdbfe;
        }

        /* Assign card */
        .wf-assign-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
          padding: 20px 24px;
          background: linear-gradient(135deg, rgba(37,99,235,0.04) 0%, rgba(124,58,237,0.03) 100%);
          border: 1px solid rgba(37,99,235,0.12);
          border-radius: 0 !important;
          margin: 16px 0;
          flex-wrap: wrap;
          animation: searchSlideDown 0.3s ease both;
        }

        .wf-assign-actions {
          display: flex;
          gap: 8px;
          align-items: center;
          flex-wrap: wrap;
        }

        .wf-assign-actions .btn-action-search {
          height: auto !important;
          box-sizing: border-box !important;
          justify-content: center !important;
        }

        .wf-assign-actions .btn-danger-search {
          padding: 8px 12px !important;
          min-width: 38px !important;
        }

        .wf-assign-info {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .wf-assign-avatar {
          width: 44px;
          height: 44px;
          border-radius: 0 !important;
          background: linear-gradient(135deg, #2563eb, #7c3aed);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 18px;
          flex-shrink: 0;
        }

        .wf-assign-meta strong {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 3px;
        }

        .wf-assign-meta span {
          display: inline-flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
          font-size: 12px;
          color: #64748b;
          font-weight: 600;
        }

        /* Enhanced Applications Column Layout */
        .wf-app-name-card {
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 12px !important;
          padding: 12px 14px !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.02) !important;
          transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          flex-wrap: nowrap !important;
          width: 100%;
          box-sizing: border-box;
          cursor: pointer !important;
        }

        .wf-app-name-card:hover {
          border-color: #2563eb !important;
          box-shadow: 0 4px 16px -4px rgba(37, 99, 235, 0.15) !important;
          transform: translateY(-1px) !important;
          background: #fafbff !important;
        }

        .wf-app-actions-card {
          background: #ffffff !important;
          border: 1px solid #eef2f6 !important;
          border-radius: 12px !important;
          padding: 12px 14px !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
          transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex;
          flex-direction: column;
          gap: 8px;
          width: 100%;
          box-sizing: border-box;
        }

        .wf-app-actions-card:hover {
          border-color: #cbd5e1 !important;
          box-shadow: 0 4px 12px -2px rgba(15, 23, 42, 0.06) !important;
          transform: translateY(-1px) !important;
        }

        .wf-app-header-left {
          display: flex;
          align-items: center;
          gap: 6px;
          flex-wrap: nowrap !important;
          min-width: 0;
          flex: 1;
          overflow: hidden;
        }

        .wf-app-title-text {
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #0f172a !important;
          letter-spacing: -0.2px;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          line-height: 1.4 !important;
        }

        .wf-app-title-text.is-link {
          cursor: pointer !important;
          color: #2563eb !important;
          text-decoration: none !important;
          transition: color 0.15s ease, text-decoration 0.15s ease !important;
        }

        .wf-app-title-text.is-link:hover {
          color: #1d4ed8 !important;
          text-decoration: underline !important;
        }

        .wf-app-id-text {
          font-size: 10.5px !important;
          font-weight: 600 !important;
          color: #94a3b8 !important;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 0;
          padding: 2px 5px;
          flex-shrink: 0;
        }

        .wf-app-status-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          height: 22px !important;
          min-width: 82px !important;
          padding: 0 8px !important;
          border-radius: 0 !important;
          font-size: 9.5px !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
          border: 1px solid transparent !important;
          white-space: nowrap !important;
          flex-shrink: 0;
        }

        .wf-app-status-badge.is-complete {
          background: #2dce898c !important;
          border-color: #2dce89 !important;
          color: #000000 !important;
        }

        .wf-app-status-badge.is-review {
          background: var(--yellow) !important;
          border-color: #e6c000 !important;
          color: #000000 !important;
        }
      `}</style>

      <div className="col-md-12">
        <div className="card mb-4 shadow-none wf-main-card list-subcontractor-page">
          {isLoading && <div className="wf-loading-bar" />}

          <div className="wf-card-header-bar">
            <div className="wf-header-left">
              <PageSizeOptions
                pageSize={pageSize}
                onChange={handlePageSizeChanged}
              />
              <span className="wf-stats-chip">
                <i className="fa fa-users" aria-hidden="true" />
                <span>{rowsCount} Subcontractors</span>
              </span>
            </div>
            <div className="wf-header-actions">
              {candidateListLink && (
                <button
                  className="btn-search-trigger wf-header-action-btn"
                  onClick={() => navigate(
                    candidateListLink.returnTo || "/ListCondidate/application",
                    {
                      state: {
                        restoreCandidateList: true,
                        candidateListState: candidateListLink.candidateListState,
                      },
                    },
                  )}
                >
                  <i className="fa fa-arrow-left" /> Back to Candidates
                </button>
              )}
              <button
                className="btn-search-trigger wf-header-action-btn"
                onClick={handleSearchShowHide}
              >
                <i
                  className={`fa ${filterShowHide ? "fa-times" : "fa-filter"}`}
                  aria-hidden="true"
                />{" "}
                {filterShowHide ? "Close Filters" : "Filters"}
              </button>
              <button
                className="btn-search-trigger wf-header-action-btn"
                onClick={handleRefresh}
                title="Reload subcontractors"
              >
                <i className="fa fa-refresh" aria-hidden="true" /> Refresh
              </button>
            </div>
          </div>

          {filterShowHide && (
            <div className="px-3 mt-2">
              <div className="search-panel-collapse">
                <div className="sp-header">
                  <span className="sp-header-title">
                    <i className="fa fa-sliders" />
                    Filter Subcontractors
                  </span>
                  <span className="sp-header-badge">
                    <i className="fa fa-filter" /> Advanced Search
                  </span>
                </div>

                <div className="sp-body">
                  <div className="row">
                    <div className="col-md-2 form-group mb-3">
                      <label htmlFor="subId" className="wf-control-label">
                        <i className="fa fa-hashtag" /> ID
                      </label>
                      <div className="wf-input-wrap">
                        <i
                          className="fa fa-hashtag wf-input-icon"
                          aria-hidden="true"
                        />
                        <input
                          type="text"
                          name="subId"
                          id="subId"
                          className="form-control wf-input"
                          placeholder="ID"
                          value={subId}
                          onChange={({ currentTarget }) =>
                            setSubId(currentTarget.value)
                          }
                          onKeyDown={(e) => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-md-5 form-group mb-3">
                      <label
                        htmlFor="subcontractorId"
                        className="wf-control-label"
                      >
                        <i className="fa fa-building" /> Subcontractor
                      </label>
                      <SearchableSelect
                        id="subcontractorId"
                        name="subcontractorId"
                        placeholder="Select Subcontractor"
                        value={subcontractorId}
                        onChange={setSubcontractorId}
                        options={(filterSubcontractorList || []).map((item) => ({
                          value: item.fuid,
                          label: `${item.label} - ${item.fuid}`,
                        }))}
                      />
                    </div>

                    <div className="col-md-5 form-group mb-3">
                      <label htmlFor="subEmail" className="wf-control-label">
                        <i className="fa fa-envelope" /> Email
                      </label>
                      <div className="wf-input-wrap">
                        <i
                          className="fa fa-envelope wf-input-icon"
                          aria-hidden="true"
                        />
                        <input
                          type="text"
                          name="subEmail"
                          id="subEmail"
                          className="form-control wf-input"
                          placeholder="Email"
                          value={subEmail}
                          onChange={({ currentTarget }) =>
                            setSubEmail(currentTarget.value)
                          }
                          onKeyDown={(e) => e.key === "Enter" && handleFilter()}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="sp-footer">
                  <button
                    className="btn-action-search btn-danger-search"
                    onClick={() => handleFilterCancel("close")}
                  >
                    <i className="fa fa-times" aria-hidden="true" /> Clear &amp; Close
                  </button>
                  <button
                    className="btn-action-search"
                    onClick={() => handleFilterCancel("refresh")}
                  >
                    <i className="fa fa-refresh" aria-hidden="true" /> Reset
                  </button>
                  <button
                    className="btn-action-search btn-primary-search"
                    onClick={() => handleFilter()}
                    disabled={!subId?.trim() && !subcontractorId && !subEmail?.trim()}
                  >
                    <i className="fa fa-search" aria-hidden="true" /> Apply Filters
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="card-body px-3 pt-2 pb-3 wf-tabs-container">
            <div className="wf-tab-bar">
              <button
                className={`wf-tab-btn${selectedTab === "home" ? " active" : ""}`}
                onClick={() => handleTabOnSelect("home")}
              >
                <i className="fa fa-list-alt" />
                Subcontractors
                <span className="wf-tab-badge">
                  {subcontractors.length > 0 ? rowsCount : "—"}
                </span>
              </button>

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTab === "addEditSubcontractor" ? " active" : ""}`}
                  onClick={() => handleTabOnSelect("addEditSubcontractor")}
                >
                  <i
                    className={`fa ${selectedSubcontractorId === 0 ? "fa-plus-circle" : "fa-edit"}`}
                  />
                  {selectedSubcontractorId === 0 ? "Add" : "Edit"} Subcontractor
                  {selectedSubcontractorId > 0 && (
                    <span className="wf-tab-badge">#{selectedSubcontractorId}</span>
                  )}
                </button>
              )}

              {type === "partner" && (
                <button
                  className={`wf-tab-btn${selectedTab === "status" ? " active" : ""}${selectedSubcontractorId === 0 ? " tab-locked" : ""}`}
                  onClick={() => handleTabOnSelect("status")}
                >
                  <i className="fa fa-toggle-on" />
                  Activate/Deactivate
                  {selectedSubcontractorId > 0 && (
                    <span className="wf-tab-badge">#{selectedSubcontractorId}</span>
                  )}
                </button>
              )}

              {type === "partner" && (
                <button
                  className={`wf-tab-btn${selectedTab === "users" ? " active" : ""}${selectedSubcontractorId === 0 ? " tab-locked" : ""}`}
                  onClick={() => {
                    if (selectedSubcontractorId > 0) {
                      handlePartnerPerformer();
                    } else {
                      handleTabOnSelect("users");
                    }
                  }}
                >
                  <i className="fa fa-user-plus" />
                  Assign/Manage Users
                  {selectedSubcontractorId > 0 && (
                    <span className="wf-tab-badge">#{selectedSubcontractorId}</span>
                  )}
                </button>
              )}

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTab === "contracts" ? " active" : ""}`}
                  onClick={() => handleTabOnSelect("contracts")}
                >
                  <i className="fa fa-file-text-o" />
                  Contract Documents
                  {selectedApp ? (
                    <span className="wf-tab-badge">
                      {docsCount}
                    </span>
                  ) : null}
                </button>
              )}

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTab === "ach" ? " active" : ""}`}
                  onClick={() => handleTabOnSelect("ach")}
                >
                  <i className="fa fa-bank" />
                  ACH Information
                  {selectedApp ? (
                    <span className="wf-tab-badge">
                      {selectedApp?.achRequest || 0}
                    </span>
                  ) : null}
                </button>
              )}

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTab === "insurance" ? " active" : ""}`}
                  onClick={() => handleTabOnSelect("insurance")}
                >
                  <i className="fa fa-shield" />
                  Insurance Information
                  {selectedApp ? (
                    <span className="wf-tab-badge">
                      {selectedApp?.insuranceRequest || 0}
                    </span>
                  ) : null}
                </button>
              )}

              {type === "application" && (
                <button
                  className={`wf-tab-btn${selectedTab === "onboardingForm" ? " active" : ""}`}
                  onClick={() => {
                    if (selectedSubcontractorId > 0 && selectedObj) {
                      handleOpenSubcontractorForm(selectedObj);
                    }
                    handleTabOnSelect("onboardingForm");
                  }}
                >
                  <i className="fa fa-list-alt" />
                  Onboarding Form
                </button>
              )}
            </div>

            <div className="wf-tab-panel">
              {selectedTab === "home" && (
                <div className="mt-3">
                  {/* Selected subcontractor context card */}
                  {selectedSubcontractorId > 0 && selectedObj && (
                    <div
                      className="wf-assign-card"
                      style={{ marginTop: 8, marginBottom: 14 }}
                    >
                      <div className="wf-assign-info">
                        <div className="wf-assign-avatar">
                          {getInitial(selectedObj.label)}
                        </div>
                        <div className="wf-assign-meta">
                          <strong>
                            {selectedObj.label || "Subcontractor"}
                          </strong>
                          <span>
                            {getContactEmail(selectedObj) ||
                              "No email available"}
                            &nbsp;&bull;&nbsp;
                            ID: #{selectedObj.fuid}
                            &nbsp;&bull;&nbsp;
                            <span
                              className={`wf-context-status ${selectedObj.enrollmentStatus ? "is-complete" : "is-pending"}`}
                            >
                              {selectedObj.enrollmentStatus
                                ? "Complete"
                                : "Pending"}
                            </span>
                            {type === "partner" && (
                              <>
                                &nbsp;&bull;&nbsp;
                                {selectedObj.activeUsers || 0} active users
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="wf-assign-actions">
                        {type === "application" && (
                          <>
                            <button
                              className="btn-action-search"
                              onClick={() =>
                                handleTabOnSelect("addEditSubcontractor")
                              }
                            >
                              Edit
                            </button>
                            <button
                              className="btn-action-search"
                              disabled={!selectedApp}
                              onClick={() => handleTabOnSelect("contracts")}
                            >
                              Contracts
                            </button>
                            <button
                              className="btn-action-search"
                              disabled={!selectedApp}
                              onClick={() => handleTabOnSelect("ach")}
                            >
                              ACH
                            </button>
                            <button
                              className="btn-action-search"
                              disabled={!selectedApp}
                              onClick={() => handleTabOnSelect("insurance")}
                            >
                              Insurance
                            </button>
                            <button
                              className="btn-action-search"
                              disabled={!selectedApp}
                              onClick={() => {
                                handleOpenSubcontractorForm(selectedObj);
                              }}
                            >
                              Onboarding Form
                            </button>
                          </>
                        )}
                        {type === "partner" && (
                          <>
                            <button
                              className="btn-action-search"
                              onClick={() => handleTabOnSelect("status")}
                            >
                              Activate/Deactivate
                            </button>
                            <button
                              className="btn-action-search"
                              onClick={handlePartnerPerformer}
                            >
                              Manage Users
                            </button>
                          </>
                        )}
                        <button
                          className="btn-action-search btn-danger-search"
                          onClick={handleResetSelection}
                          title="Clear selection"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="wf-table-scroll">
                    <table
                      className={`wf-table wf-table-modern table-striped ${type === "application"
                        ? "wf-table-application"
                        : "wf-table-partner"
                        }`}
                    >
                      <thead className="wf-thead">
                        <tr>
                          <th
                            style={{
                              width: type === "partner" ? "25%" : "25%",
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <span>Subcontractor</span>
                              {selectedSubcontractorId > 0 && (
                                <button
                                  type="button"
                                  className="wf-reset-selection"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleResetSelection();
                                  }}
                                  title="Clear selection"
                                  style={{ margin: 0, padding: "2px 6px", height: "20px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}
                                >
                                  <i className="fa fa-refresh" style={{ fontSize: "10px" }} />
                                </button>
                              )}
                            </div>
                          </th>
                          <th
                            style={{
                              width: type === "partner" ? "35%" : "35%",
                            }}
                          >
                            Onboarding
                          </th>
                          <th
                            style={{
                              width:
                                type === "partner"
                                  ? "15%"
                                  : type === "application"
                                    ? "15%"
                                    : undefined,
                            }}
                          >
                            Status
                          </th>
                          {type !== "partner" && (
                            <th style={{ width: "25%" }}>Key Contact</th>
                          )}
                          {type === "partner" && (
                            <>
                              <th style={{ width: "10%" }}>Total Users</th>
                              <th style={{ width: "15%" }}>Activation</th>
                            </>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          Array.from({
                            length: pageSize > 5 ? 5 : pageSize,
                          }).map((_, i) => (
                            <tr
                              key={`subcontractor-skel-${i}`}
                              className="skeleton-row"
                            >
                              <td
                                style={{
                                  width: type === "partner" ? "25%" : "25%",
                                }}
                              >
                                <div className="skeleton-identity">
                                  <span
                                    className="skeleton-cell sk-avatar"
                                    style={{ animationDelay: `${i * 0.04}s` }}
                                  />
                                  <div className="skeleton-stack">
                                    <span
                                      className="skeleton-cell sk-medium"
                                      style={{ animationDelay: `${i * 0.05}s` }}
                                    />
                                    <span
                                      className="skeleton-cell sk-long"
                                      style={{ animationDelay: `${i * 0.07}s` }}
                                    />
                                    <span
                                      className="skeleton-cell sk-short"
                                      style={{ animationDelay: `${i * 0.06}s` }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td
                                style={{
                                  width: type === "partner" ? "35%" : "35%",
                                }}
                              >
                                <span
                                  className="skeleton-cell sk-long"
                                  style={{ animationDelay: `${i * 0.06}s` }}
                                />
                              </td>
                              <td
                                style={{
                                  width:
                                    type === "partner"
                                      ? "15%"
                                      : type === "application"
                                        ? "15%"
                                        : undefined,
                                }}
                              >
                                <span
                                  className="skeleton-cell sk-short"
                                  style={{ animationDelay: `${i * 0.04}s` }}
                                />
                              </td>
                              {type !== "partner" && (
                                <td style={{ width: "25%" }}>
                                  <div className="skeleton-stack">
                                    <span
                                      className="skeleton-cell sk-medium"
                                      style={{ animationDelay: `${i * 0.08}s` }}
                                    />
                                    <span
                                      className="skeleton-cell sk-long"
                                      style={{ animationDelay: `${i * 0.05}s` }}
                                    />
                                  </div>
                                </td>
                              )}
                              {type === "partner" && (
                                <>
                                  <td style={{ width: "10%" }}>
                                    <span
                                      className="skeleton-cell sk-short"
                                      style={{ animationDelay: `${i * 0.05}s` }}
                                    />
                                  </td>
                                  <td style={{ width: "15%" }}>
                                    <span
                                      className="skeleton-cell sk-medium"
                                      style={{ animationDelay: `${i * 0.07}s` }}
                                    />
                                  </td>
                                </>
                              )}
                            </tr>
                          ))
                        ) : subcontractors.length === 0 ? (
                          <tr>
                            <td colSpan={type === "partner" ? 5 : 4} style={{ padding: 0 }}>
                              <div className="wf-empty-state">
                                <div className="wf-empty-icon">
                                  <i
                                    className={
                                      dataType === "filter"
                                        ? "fa fa-search"
                                        : "fa fa-list-alt"
                                    }
                                  />
                                </div>
                                <p className="wf-empty-title">
                                  {dataType === "filter"
                                    ? "No Matching Subcontractors"
                                    : "No Subcontractors Found"}
                                </p>
                                <p className="wf-empty-desc">
                                  {dataType === "filter"
                                    ? "Try adjusting or resetting the filters to see subcontractors."
                                    : "There are no subcontractors available yet. Once created, they will appear here."}
                                </p>
                                {dataType === "filter" && (
                                  <button
                                    className="btn-action-search"
                                    onClick={() =>
                                      handleFilterCancel("refresh")
                                    }
                                    style={{ marginTop: 4 }}
                                  >
                                    <i
                                      className="fa fa-refresh"
                                      aria-hidden="true"
                                    />
                                    Reset Filters
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ) : (
                          subcontractors.map((item, idx) => (
                            <tr
                              key={item.fuid}
                              className={`wf-table-row ${selectedSubcontractorId === item.fuid ? "selected-row" : ""}`}
                              onClick={() => handleSelectSubcontrator(item)}
                              style={{ animationDelay: `${idx * 0.04}s` }}
                              title={selectedSubcontractorId === item.fuid ? `Click to deselect: ${item.label || "Subcontractor"}` : `Click to select: ${item.label || "Subcontractor"}`}
                            >
                              <td
                                style={{
                                  width: type === "partner" ? "25%" : "25%",
                                }}
                              >
                                <div className="wf-identity-cell">
                                  <div className="wf-avatar-stack" style={{ position: "relative" }}>
                                    <KeyContactAvatar contact={item.contact1} />
                                    {selectedSubcontractorId === item.fuid && (
                                      <div className="wf-avatar-check-badge">
                                        <i className="fa fa-check" />
                                      </div>
                                    )}
                                    <span className="wf-inline-id">
                                      #{item.fuid}
                                    </span>
                                  </div>
                                  <div className="wf-identity-copy">
                                    <div className="wf-identity-heading">
                                      <span className="wf-identity-title">
                                        {item.label || "Subcontractor"}
                                      </span>
                                    </div>

                                    <div className="wf-identity-meta-row">
                                      <div className="wf-identity-meta-icon wf-icon-email">
                                        <i className="fa fa-envelope-o" />
                                      </div>
                                      <span className="wf-identity-meta-text">
                                        {getContactEmail(item) || "No email available"}
                                      </span>
                                    </div>

                                    {item.createdDate && (
                                      <div className="wf-identity-meta-row">
                                        <div className="wf-identity-meta-icon wf-icon-calendar">
                                          <i className="fa fa-calendar-o" />
                                        </div>
                                        <span className="wf-identity-meta-text">
                                          <Moment format="MMM Do YYYY">
                                            {item.createdDate}
                                          </Moment>
                                        </span>
                                      </div>
                                    )}

                                    {(item.accessKey || item.portalUrl || item.city || item.state || item.zip) && (
                                      <div className="wf-identity-meta-row">
                                        <div className="wf-identity-meta-icon wf-icon-address">
                                          <i className="fa fa-map-marker" />
                                        </div>
                                        <span className="wf-identity-meta-text wf-identity-address-text">
                                          {getAddressLines(item).map(
                                            (line, lineIndex) => (
                                              <span key={lineIndex}>
                                                {line}
                                              </span>
                                            ),
                                          )}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </td>

                              <td
                                style={{
                                  width: type === "partner" ? "35%" : "25%",
                                }}
                              >
                                <div
                                  className="wf-app-list"
                                  onClick={(event) => event.stopPropagation()}
                                  title=""
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                    width: "100%",
                                    boxSizing: "border-box",
                                  }}
                                >
                                  {item.applications?.length > 0 ? (
                                    item.applications.map((app) => (
                                      <React.Fragment key={app.applicationId}>
                                        {type === "partner" && (
                                          <div
                                            className="wf-app-name-card"
                                            onClick={() => {
                                              handlePartnerApplication(item, app);
                                            }}
                                            title="Open application review"
                                            style={{ cursor: "pointer" }}
                                          >
                                            <div
                                              className="wf-app-header-left"
                                              style={{
                                                flex: 1,
                                                minWidth: 0,
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <div className="wf-app-icon-wrapper" style={{ marginRight: "6px" }}>
                                                <i className="fa fa-file-text-o" />
                                              </div>
                                              <span
                                                className="wf-app-title-text"
                                                style={{
                                                  flex: 1,
                                                  minWidth: 0,
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                {app.applicationType ||
                                                  "Application"}
                                              </span>
                                              <span
                                                className="wf-app-id-text"
                                                style={{
                                                  flexShrink: 0,
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                #{app.applicationId}
                                              </span>
                                            </div>
                                          </div>
                                        )}

                                        {/* Second Card: Action Buttons */}
                                        {type === "application" && (
                                          <div className="wf-app-actions-card">
                                            <div
                                              className="wf-action-stack"
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "6px",
                                              }}
                                            >
                                              {/* Row 1: Application button */}
                                              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                                <button
                                                  type="button"
                                                  className="wf-tool-btn is-app"
                                                  onClick={() =>
                                                    handlePartnerApplication(item, app)
                                                  }
                                                  title="Open application review"
                                                >
                                                  {app.applicationType || "Subcontractor Application"}
                                                  <span className="wf-tool-count is-id">
                                                    #{app.applicationId}
                                                  </span>
                                                </button>
                                              </div>

                                              {/* Row 2: Remaining action buttons */}
                                              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                                <button
                                                  type="button"
                                                  className="wf-tool-btn is-form"
                                                  onClick={() =>
                                                    handleOpenSubcontractorForm(
                                                      item,
                                                    )
                                                  }
                                                  title="Subcontractor form"
                                                >
                                                  Onboarding Form
                                                </button>

                                                <button
                                                  type="button"
                                                  className="wf-tool-btn is-docs"
                                                  onClick={() =>
                                                    handleWorkflowPanelOpen(
                                                      "contracts",
                                                      item,
                                                      app,
                                                    )
                                                  }
                                                  title="Contract Documents"
                                                >
                                                  Document
                                                  {selectedSubcontractorId === item.fuid && (
                                                    <span className="wf-tool-count">
                                                      {docsCount}
                                                    </span>
                                                  )}
                                                </button>

                                                <button
                                                  type="button"
                                                  className="wf-tool-btn is-ach"
                                                  onClick={() =>
                                                    handleWorkflowPanelOpen(
                                                      "ach",
                                                      item,
                                                      app,
                                                    )
                                                  }
                                                  title="ACH Information"
                                                >
                                                  ACH
                                                  {app?.achRequest > 0 && (
                                                    <span className="wf-tool-count">
                                                      {app.achRequest}
                                                    </span>
                                                  )}
                                                </button>

                                                <button
                                                  type="button"
                                                  className="wf-tool-btn is-insurance"
                                                  onClick={() =>
                                                    handleWorkflowPanelOpen(
                                                      "insurance",
                                                      item,
                                                      app,
                                                    )
                                                  }
                                                  title="Insurance Information"
                                                >
                                                  Insurance
                                                  {app?.insuranceRequest > 0 && (
                                                    <span className="wf-tool-count">
                                                      {app.insuranceRequest}
                                                    </span>
                                                  )}
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </React.Fragment>
                                    ))
                                  ) : (
                                    <span className="wf-muted-text">
                                      No applications
                                    </span>
                                  )}
                                </div>
                              </td>

                              <td
                                style={{
                                  width:
                                    type === "partner"
                                      ? "15%"
                                      : type === "application"
                                        ? "15%"
                                        : undefined,
                                }}
                              >
                                <div className="wf-status-stack">
                                  {item.applications?.length > 0 ? (
                                    item.applications.map((app) => (
                                      <span
                                        key={`ob-status-${app.applicationId}`}
                                        className={`wf-app-status-badge ${app.appSubmitted ? "is-complete" : "is-review"}`}
                                        style={{ minWidth: "78px", width: "auto", padding: "0 10px", whiteSpace: "nowrap", justifyContent: "center" }}
                                      >
                                        {app.appSubmitted ? "Complete" : "Review"}
                                      </span>
                                    ))
                                  ) : (
                                    <span
                                      className={`wf-status-pill ${item.enrollmentStatus ? "is-complete" : "is-pending"}`}
                                    >
                                      <i
                                        className={`fa ${item.enrollmentStatus ? "fa-check-circle" : "fa-clock-o"}`}
                                      />
                                      {item.enrollmentStatus
                                        ? "Complete"
                                        : "Pending"}
                                    </span>
                                  )}
                                </div>
                                {item.contact1 !== null &&
                                  type === "partner" &&
                                  !item.enrollmentStatus && (
                                    <div
                                      className="wf-row-actions mt-2"
                                      onClick={(event) =>
                                        event.stopPropagation()
                                      }
                                      title=""
                                    >
                                      <button
                                        type="button"
                                        className="wf-link-action"
                                        onClick={() =>
                                          handleRemainder(
                                            item.contact1.performerid,
                                          )
                                        }
                                      >
                                        <i className="fa fa-bell-o" />
                                        Reminder
                                      </button>{" "}
                                      <button
                                        type="button"
                                        className="wf-link-action"
                                        title="View message"
                                        onClick={handleRemainderMessage}
                                      >
                                        <i className="fa fa-envelope-o" />
                                        {item.countReminderMsg}
                                      </button>
                                    </div>
                                  )}
                              </td>
                              {type !== "partner" && (
                                <td style={{ width: "25%" }}>
                                  {item.contact1 !== null ? (
                                    <div className="wf-contact-card">
                                      <div className="wf-identity-meta-row">
                                        <div className="wf-identity-meta-icon wf-icon-user">
                                          <i className="fa fa-user-circle-o" />
                                        </div>
                                        <span className="wf-contact-name" style={{ marginTop: "1px" }}>
                                          {getContactName(item.contact1)}
                                        </span>
                                      </div>

                                      <div className="wf-identity-meta-row">
                                        <span className="wf-identity-meta-text">
                                          {item.contact1.performeremail || "No email available"}
                                        </span>
                                      </div>

                                      {item.contact1?.contactNo && (
                                        <div className="wf-identity-meta-row">
                                          <div className="wf-identity-meta-icon wf-icon-phone">
                                            <i className="fa fa-phone" />
                                          </div>
                                          <span className="wf-identity-meta-text">
                                            {getFormatedNumber(item.contact1.contactNo)}
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    <span className="wf-muted-text">
                                      No contact assigned
                                    </span>
                                  )}
                                </td>
                              )}
                              {type === "partner" && (
                                <>
                                  <td style={{ width: "10%" }}>
                                    <span className="wf-count-pill">
                                      <i className="fa fa-users" />
                                      {item.activeUsers || 0}
                                    </span>
                                  </td>
                                  <td
                                    style={{ width: "15%" }}
                                    onClick={(event) => event.stopPropagation()}
                                    title=""
                                  >
                                    <div className="wf-activation-stack">
                                      <span
                                        className={`wf-status-pill ${getActivationStatus(item.contact1).className}`}
                                      >
                                        <i
                                          className={`fa ${getActivationStatus(item.contact1).icon}`}
                                        />
                                        {
                                          getActivationStatus(item.contact1)
                                            .label
                                        }
                                      </span>

                                      {item.contact1?.addedDateTime && (
                                        <div className="wf-identity-meta-row">
                                          <div className="wf-identity-meta-icon wf-icon-calendar">
                                            <i className="fa fa-calendar-o" />
                                          </div>
                                          <span className="wf-identity-meta-text">
                                            <Moment format="MMM Do YYYY">
                                              {item.contact1.addedDateTime}
                                            </Moment>
                                          </span>
                                        </div>
                                      )}

                                      {item.contact1?.isActive !== null &&
                                        item.contact1?.performerid && (
                                          <button
                                            type="button"
                                            className="wf-link-action"
                                            onClick={() =>
                                              handleRemainder(
                                                item.contact1.performerid,
                                              )
                                            }
                                            style={{ alignSelf: "flex-start" }}
                                          >
                                            <i className="fa fa-paper-plane-o" />
                                            Resend activation
                                          </button>
                                        )}
                                    </div>
                                  </td>
                                </>
                              )}
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>

                    {!isLoading && subcontractors.length > 0 && (
                      <div className="mt-3">
                        <Pagination
                          currentPage={currentPage}
                          pageSize={pageSize}
                          itemsCount={rowsCount}
                          onPageChange={handlePageChange}
                          startIndex={startIndex}
                          endIndex={endIndex}
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}

              {selectedTab === "addEditSubcontractor" &&
                type === "application" && (
                  <form
                    className="mt-3"
                    autoComplete="off"
                    onSubmit={(e) => e.preventDefault()}
                  >
                    <AddSubcontractor
                      selectedObj={selectedObj}
                      handleAddEditSubcontractor={handleAddEditSubcontractor}
                      selectedTab={selectedTab}
                    />
                  </form>
                )}

              {["contracts", "ach", "insurance"].includes(selectedTab) &&
                type === "application" && (
                  <div className="wf-tab-panel pt-3">
                    {!selectedApp || !selectedWorkflowItem ? (
                      <div className="wf-empty-state">
                        <div className="wf-empty-icon">
                          <i
                            className={`fa ${selectedTab === "contracts"
                              ? "fa-file-text-o"
                              : selectedTab === "ach"
                                ? "fa-bank"
                                : "fa-shield"
                              }`}
                          />
                        </div>
                        <p className="wf-empty-title">
                          No Subcontractor Selected
                        </p>
                        <p className="wf-empty-desc">
                          Select a subcontractor application from the table to
                          view{" "}
                          {selectedTab === "contracts" && "contracts documents"}
                          {selectedTab === "ach" && "ACH information"}
                          {selectedTab === "insurance" &&
                            "insurance information"}
                          .
                        </p>
                        <button
                          className="btn-action-search"
                          onClick={() => handleTabOnSelect("home")}
                          style={{ marginTop: 4 }}
                        >
                          <i className="fa fa-arrow-left" /> Back to
                          Subcontractors
                        </button>
                      </div>
                    ) : (
                      <div className="wf-panel-shell" style={{ border: "none", background: "transparent", padding: 0 }}>
                        {selectedTab === "contracts" && (
                          <Document
                            documents={appDocuments}
                            workflowTask={selectedCurrentTask}
                            uploadType={"Subcontractor"}
                            app={selectedApp}
                            item={selectedWorkflowItem}
                            prevItem={null}
                            viewType={"subList"}
                            onBack={() => handleTabOnSelect("home")}
                          />
                        )}

                        {selectedTab === "ach" && (
                          <AchInformation
                            workflowTask={selectedCurrentTask}
                            app={selectedApp}
                            item={selectedWorkflowItem}
                            setViewBprmFormShowHide={setViewBprmFormShowHide}
                            viewType={"subcontractorList"}
                            achType={"Subcontractor"}
                            setSelectedApp={setSelectedApp}
                            onBack={() => handleTabOnSelect("home")}
                          />
                        )}

                        {selectedTab === "insurance" && (
                          <InsuranseInformation
                            workflowTask={selectedCurrentTask}
                            app={selectedApp}
                            item={selectedWorkflowItem}
                            setViewBprmFormShowHide={setViewBprmFormShowHide}
                            viewType={"subcontractorList"}
                            insuranceType={"Subcontractor"}
                            setSelectedApp={setSelectedApp}
                            onBack={() => handleTabOnSelect("home")}
                          />
                        )}
                      </div>
                    )}
                  </div>
                )}

              {selectedTab === "onboardingForm" && type === "application" && (
                <div className="wf-tab-panel pt-2">
                  {!selectedObj ? (
                    <div className="wf-empty-state">
                      <div className="wf-empty-icon">
                        <i className="fa fa-list-alt" />
                      </div>
                      <p className="wf-empty-title">Onboarding Form</p>
                      <p className="wf-empty-desc">
                        Select an onboarding form from the subcontractor table to view details.
                      </p>
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabOnSelect("home")}
                        style={{ marginTop: 4 }}
                      >
                        <i className="fa fa-arrow-left" /> Back
                      </button>
                    </div>
                  ) : (
                    <div className="wf-onboarding-panel">
                      {/* Form Styles */}
                      <style>{`
                        .as-form-header {
                          display: flex !important;
                          align-items: flex-start !important;
                          justify-content: space-between !important;
                          flex-wrap: wrap !important;
                          gap: 18px !important;
                          padding: 22px 24px 18px !important;
                          background: #ffffff !important;
                          border-bottom: 1px solid #e2e8f0 !important;
                          border-radius: 0 !important;
                          position: relative !important;
                          overflow: hidden !important;
                        }
                        .as-form-header-left {
                          display: flex !important;
                          align-items: flex-start !important;
                          gap: 14px !important;
                          min-width: 260px !important;
                          flex: 1 1 360px !important;
                        }
                        .as-form-header-right {
                          display: flex !important;
                          align-items: center !important;
                          gap: 8px !important;
                          flex-wrap: wrap !important;
                          justify-content: flex-end !important;
                          margin-left: auto !important;
                          position: relative !important;
                          z-index: 1 !important;
                          flex-shrink: 0 !important;
                        }
                        .as-header-back-btn {
                          background: #ffffff !important;
                          border: 1px solid #cbd5e1 !important;
                          border-radius: 0 !important;
                          padding: 0 14px !important;
                          color: #1e293b !important;
                          font-size: 14px !important;
                          font-weight: 500 !important;
                          display: inline-flex !important;
                          align-items: center !important;
                          gap: 8px !important;
                          cursor: pointer !important;
                          transition: all 0.2s ease !important;
                          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
                          outline: none !important;
                          height: 34px !important;
                          min-height: 34px !important;
                        }
                        .as-header-back-btn:hover {
                          background: #f8fafc !important;
                          border-color: #94a3b8 !important;
                          color: #1e293b !important;
                          transform: translateY(-1px) !important;
                        }
                        .as-header-back-btn i {
                          color: #1e293b !important;
                        }
                        .as-form-header-icon {
                          width: 42px !important;
                          height: 42px !important;
                          border-radius: 0 !important;
                          background: #ffffff !important;
                          border: 1px solid #cbd5e1 !important;
                          display: flex !important;
                          align-items: center !important;
                          justify-content: center !important;
                          color: #1e293b !important;
                          font-size: 18px !important;
                          flex-shrink: 0 !important;
                          box-shadow: none !important;
                        }
                        .as-form-header-text {
                          position: relative !important;
                          z-index: 1 !important;
                        }
                        .as-form-header-title {
                          color: #1e293b !important;
                          font-size: 18px !important;
                          font-weight: 500 !important;
                          margin: 0 !important;
                          line-height: 1.2 !important;
                        }
                        .as-form-header-sub {
                          color: #64748b !important;
                          font-size: 13px !important;
                          margin-top: 6px !important;
                          font-weight: 500 !important;
                          max-width: 620px !important;
                        }
                        .as-form-header-meta {
                          display: flex !important;
                          align-items: center !important;
                          gap: 7px !important;
                          flex-wrap: wrap !important;
                          margin-top: 10px !important;
                        }
                        .as-meta-pill {
                          display: inline-flex !important;
                          align-items: center !important;
                          gap: 5px !important;
                          padding: 3px 8px !important;
                          height: 24px !important;
                          min-height: 24px !important;
                          box-sizing: border-box !important;
                          border-radius: 0 !important;
                          background: #ffffff !important;
                          border: 1px solid #cbd5e1 !important;
                          color: #0f172a !important;
                          font-size: 11px !important;
                          font-weight: 600 !important;
                          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
                          box-shadow: none !important;
                        }
                        .as-meta-pill i { font-size: 11px !important; }
                        .as-meta-pill.meta-id i { color: #334155 !important; }
                        .as-meta-pill.meta-person i { color: #6d28d9 !important; }
                        .as-meta-pill.meta-email i { color: #0369a1 !important; }
                        .as-meta-pill.meta-status-active i { color: #15803d !important; }
                        .as-meta-pill.meta-status-inactive i { color: #b91c1c !important; }
                        .as-meta-pill.meta-status-pending i { color: #b45309 !important; }
                        .as-meta-pill.meta-ciid i { color: #0f766e !important; }
                        .wf-onboarding-panel {
                          padding: 0 !important;
                          border: 1px solid #cbd5e1 !important;
                          border-radius: 0 !important;
                          overflow: hidden !important;
                          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04) !important;
                          background: #ffffff !important;
                          margin-top: 10px !important;
                        }
                        .wf-onboarding-panel .as-form-header {
                          margin: 0 !important;
                          border-radius: 0 !important;
                        }
                        .wf-onboarding-panel > .col-md-12.px-0 {
                          padding: 24px !important;
                          background: #ffffff !important;
                        }
                        .wf-onboarding-panel > .wf-loading-container {
                          padding: 32px 18px !important;
                          background: #ffffff !important;
                        }
                        .wf-onboarding-panel .form-control-label {
                          color: #1e293b !important;
                          font-weight: 500 !important;
                        }
                        .wf-onboarding-panel .form-control-label > i.fa,
                        .wf-onboarding-panel .wf-input-icon {
                          display: none !important;
                        }
                        .wf-onboarding-panel .wf-input-wrap > .form-control,
                        .wf-onboarding-panel .wf-input-wrap .d-flex > .form-control,
                        .wf-onboarding-panel .wf-input-wrap > .form-control:not(textarea),
                        .wf-onboarding-panel .wf-input-wrap .d-flex > .form-control:not(textarea),
                        .wf-onboarding-panel .form-control:not(textarea),
                        .wf-onboarding-panel select,
                        .wf-onboarding-panel input:not(textarea) {
                          height: 38px !important;
                          min-height: 38px !important;
                          max-height: 38px !important;
                          box-sizing: border-box !important;
                          line-height: normal !important;
                          padding: 0 12px !important;
                          border: 1px solid #cbd5e1 !important;
                          border-radius: 0 !important;
                          color: #1e293b !important;
                          font-size: 13.5px !important;
                          font-weight: 400 !important;
                          box-shadow: none !important;
                        }
                        .wf-onboarding-panel .wf-input-wrap > .form-control:not(:disabled),
                        .wf-onboarding-panel .wf-input-wrap .d-flex > .form-control:not(:disabled),
                        .wf-onboarding-panel .form-control:not(:disabled),
                        .wf-onboarding-panel select:not(:disabled),
                        .wf-onboarding-panel input:not(:disabled) {
                          background: #ffffff !important;
                          background-color: #ffffff !important;
                        }
                        .wf-onboarding-panel .form-control:disabled,
                        .wf-onboarding-panel .form-control[disabled],
                        .wf-onboarding-panel select:disabled,
                        .wf-onboarding-panel input:disabled,
                        .wf-onboarding-panel textarea:disabled {
                          background: #f8fafc !important;
                          background-color: #f8fafc !important;
                          color: #475569 !important;
                          -webkit-text-fill-color: #475569 !important;
                          border: 1px solid #cbd5e1 !important;
                          cursor: not-allowed !important;
                          opacity: 1 !important;
                          box-shadow: none !important;
                        }
                        .wf-onboarding-panel .wf-merged-phone-wrapper {
                          height: 38px !important;
                          min-height: 38px !important;
                          border: 1px solid #cbd5e1 !important;
                          border-radius: 0 !important;
                          background: #ffffff !important;
                          box-shadow: none !important;
                        }
                        .wf-onboarding-panel .wf-merged-phone-wrapper.disabled,
                        .wf-onboarding-panel .wf-merged-phone-wrapper.is-disabled,
                        .wf-onboarding-panel .wf-merged-phone-wrapper:has(:disabled) {
                          background: #f8fafc !important;
                          background-color: #f8fafc !important;
                          border: 1px solid #cbd5e1 !important;
                        }
                        .wf-onboarding-panel .wf-merged-phone-wrapper .wf-phone-input,
                        .wf-onboarding-panel .wf-merged-phone-wrapper .wf-phone-input:disabled {
                          background: transparent !important;
                          background-color: transparent !important;
                          border: none !important;
                          box-shadow: none !important;
                          color: #475569 !important;
                          -webkit-text-fill-color: #475569 !important;
                          height: 100% !important;
                        }
                        .wf-onboarding-panel .wf-merged-phone-wrapper .wf-cc-trigger,
                        .wf-onboarding-panel .wf-merged-phone-wrapper .wf-cc-trigger--disabled {
                          background: transparent !important;
                          background-color: transparent !important;
                          border: none !important;
                          box-shadow: none !important;
                          color: #475569 !important;
                          height: 100% !important;
                        }
                        .wf-onboarding-panel .wf-input-wrap > .form-control:focus,
                        .wf-onboarding-panel .wf-input-wrap .d-flex > .form-control:focus,
                        .wf-onboarding-panel .form-control:focus,
                        .wf-onboarding-panel select:focus,
                        .wf-onboarding-panel input:focus {
                          border-color: #2563eb !important;
                          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1) !important;
                        }
                        .wf-onboarding-panel button,
                        .wf-onboarding-panel .btn,
                        .wf-onboarding-panel .wf-btn,
                        .wf-onboarding-panel .card {
                          border-radius: 0 !important;
                        }
                      `}</style>

                      {/* Form Header */}
                      <div className="as-form-header mb-4">
                        <div className="as-form-header-left">
                          <div className="as-form-header-icon">
                            <i className="fa fa-pencil-square-o" />
                          </div>
                          <div className="as-form-header-text">
                            <p className="as-form-header-title">
                              Subcontractor Onboarding Form
                            </p>
                            <div className="as-form-header-meta">
                              <span className="as-meta-pill meta-id">
                                <i className="fa fa-id-badge" /> ID: {selectedObj?.fuid || "New"}
                              </span>
                              {selectedObj?.label && (
                                <span className="as-meta-pill meta-person">
                                  <i className="fa fa-user" /> {selectedObj.label}
                                </span>
                              )}
                              {selectedObj?.email && (
                                <span className="as-meta-pill meta-email">
                                  <i className="fa fa-envelope-o" /> {selectedObj.email}
                                </span>
                              )}
                              {wfTask?.ciid > 0 && (
                                <span className="as-meta-pill meta-ciid">
                                  <i className="fa fa-hashtag" /> CIID: {wfTask.ciid}
                                </span>
                              )}
                              <span className={`as-meta-pill ${selectedObj?.contact1?.isActive === true ? 'meta-status-active' : selectedObj?.contact1?.isActive === false ? 'meta-status-inactive' : 'meta-status-pending'}`}>
                                <i className="fa fa-info-circle" /> Status: {
                                  selectedObj?.contact1?.isActive === true
                                    ? "Active"
                                    : selectedObj?.contact1?.isActive === false
                                      ? "Inactive"
                                      : "Pending Activation"
                                }
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="as-form-header-right">
                          <button
                            className="as-header-back-btn"
                            onClick={() => handleTabOnSelect("home")}
                          >
                            <i className="fa fa-arrow-left"></i> Back
                          </button>
                        </div>
                      </div>

                      {wfForm ? (
                        <form
                          className="col-md-12 px-0"
                          autoComplete="off"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <WorkflowElement
                            wfTask={wfTask}
                            wfForm={wfForm}
                            handleNextTask={() => {}}
                            viewType={true}
                            appSummary={false}
                            codeVerified={true}
                            wfTaskType={"form"}
                            updatedStateData={updatedStateData}
                          />
                        </form>
                      ) : (
                        <div className="wf-loading-container" style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "60px 20px",
                          background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                          borderRadius: "12px",
                          border: "1px solid #e2e8f0",
                          boxShadow: "0 10px 15px -3px rgba(0,0,0,0.05), 0 4px 6px -2px rgba(0,0,0,0.05)",
                          margin: "20px auto",
                          maxWidth: "480px"
                        }}>
                          <div className="wf-loader-spinner" style={{
                            position: "relative",
                            width: "64px",
                            height: "64px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}>
                            <div className="spinner-double-ring" style={{
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              border: "4px solid transparent",
                              borderTopColor: "#0f766e",
                              borderBottomColor: "#0f766e",
                              borderRadius: "50%",
                              animation: "spin 1.5s linear infinite"
                            }} />
                            <div className="spinner-inner-ring" style={{
                              position: "absolute",
                              width: "70%",
                              height: "70%",
                              border: "3px solid transparent",
                              borderLeftColor: "#2563eb",
                              borderRightColor: "#2563eb",
                              borderRadius: "50%",
                              animation: "spin-reverse 1.2s linear infinite"
                            }} />
                            <i className="fa fa-pencil-square-o" style={{ fontSize: "20px", color: "#0f766e" }} />
                          </div>
                          
                          <p style={{
                            margin: "20px 0 6px 0",
                            color: "#0f172a",
                            fontSize: "15px",
                            fontWeight: 600,
                            letterSpacing: "-0.01em"
                          }}>
                            Fetching Onboarding Schema
                          </p>
                          <p style={{
                            margin: 0,
                            color: "#64748b",
                            fontSize: "12.5px",
                            fontWeight: 600,
                            textAlign: "center"
                          }}>
                            Please wait while we retrieve the Subcontractor onboarding form details.
                          </p>
                          
                          <div style={{
                            width: "120px",
                            height: "3px",
                            background: "#e2e8f0",
                            borderRadius: "2px",
                            marginTop: "16px",
                            overflow: "hidden",
                            position: "relative"
                          }}>
                            <div style={{
                              position: "absolute",
                              height: "100%",
                              width: "40%",
                              background: "linear-gradient(90deg, #0f766e, #2563eb)",
                              borderRadius: "2px",
                              animation: "pulse-loader 1.5s infinite ease-in-out"
                            }} />
                          </div>

                          <style dangerouslySetInnerHTML={{ __html: `
                            @keyframes spin {
                              0% { transform: rotate(0deg); }
                              100% { transform: rotate(360deg); }
                            }
                            @keyframes spin-reverse {
                              0% { transform: rotate(360deg); }
                              100% { transform: rotate(0deg); }
                            }
                            @keyframes pulse-loader {
                              0% { left: -40%; }
                              50% { left: 100%; }
                              100% { left: -40%; }
                            }
                          `}} />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {selectedTab === "status" && type === "partner" && (
                <div className="mt-3 bg-white p-3 rounded border wf-tab-panel">
                  {selectedSubcontractorId === 0 ? (
                    <div className="wf-empty-state">
                      <div className="wf-empty-icon">
                        <i className="fa fa-toggle-on" />
                      </div>
                      <p className="wf-empty-title">No Subcontractor Selected</p>
                      <p className="wf-empty-desc">
                        Select a subcontractor from the table to view its activation history.
                      </p>
                      <button
                        className="btn-action-search"
                        onClick={() => handleTabOnSelect("home")}
                        style={{ marginTop: 4 }}
                      >
                        <i className="fa fa-arrow-left" /> Back to Subcontractors
                      </button>
                    </div>
                  ) : (
                    <ActiveDeactiveHistory
                      selectedObj={selectedObj}
                      type="partner"
                      typeName="Subcontractor"
                      actionType={actionType}
                      handlePermissionShowHide2={handlePermissionShowHide2}
                    />
                  )}
                </div>
              )}

              {selectedTab === "users" && selectedSubcontractorId === 0 && (
                <div className="mt-3 bg-white p-3 rounded border wf-tab-panel">
                  <div className="wf-empty-state">
                    <div className="wf-empty-icon">
                      <i className="fa fa-user-plus" />
                    </div>
                    <p className="wf-empty-title">No Subcontractor Selected</p>
                    <p className="wf-empty-desc">
                      Select a subcontractor from the table to assign or manage users.
                    </p>
                    <button
                      className="btn-action-search"
                      onClick={() => handleTabOnSelect("home")}
                      style={{ marginTop: 4 }}
                    >
                      <i className="fa fa-arrow-left" /> Back to Subcontractors
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {remainderMsgShowHide && (
        <ReminderAlertMessage
          remainderMsgShowHide={remainderMsgShowHide}
          handleRemainderMessage={handleRemainderMessage}
        />
      )}
    </React.Fragment>
  );
}

//export default ListSubcontractor;
